/* ==========================================================================
   C2V Studio (2/2) : pop-up de personnalisation Capote2Verre
   Etape Coordonnees (entreprise, prenom, nom, telephone, email + case) : le
   projet est ajoute au panier (produit miroir + fichiers en proprietes de
   ligne, coordonnees en attributs du panier) puis la fiche client est creee
   via le proxy d'app.
   Etape Paiement : redirection vers le checkout Shopify, email, nom,
   entreprise et telephone pre-remplis.
   Moteur de rendu et gabarit : c2v-studio-core.js (charge avant).
   Textes traduits : T / TP de c2v-studio-core.js (cles c2v.* des fichiers de
   langue, snippet c2v-i18n.liquid). Les proprietes visibles du panier sont
   dans la langue du client ; les proprietes cachees (_Studio, _Projet_FR,
   _Langue, _Fichier...) et la fiche client restent en francais.
   Plusieurs produits sur une meme page (page d'accueil) : une config
   [data-c2v-studio][data-c2v-key] par produit, un studio cree au premier clic
   (window.C2VStudios.open(cle, { trigger, file })). Fiches produits : une
   seule config, studio cree au chargement comme avant.
   ========================================================================== */
(() => {
  'use strict';
  if (window.C2VStudios || window.C2VStudio || !window.C2VLib) return;
  const {
    SILICONES, INKS, NATUREL_REF, ZONE_W, ZONE_H, ZONE_RATIO, MAX_FILE, $, $$, clamp, NUM, money, esc, reduceMotion, hexToRgb, rgbToHex, isHex, relLum, contrast, hsvToRgb, rgbToHsv, makeCanvas, ctx2d, loadStudioImage, renderPdf, Lid3D, TopView, Pack, fileKind, svgSource, rasterSource, analyzeLogo, buildZone, I, template,
    flatTexts, px300, fmtMm, FlatView, colorLogo, monoLogo, ORIG_INK, flattenVisual, logoOnWhite, rotate90, artThumb,
    T, TP, TFr, LOCALE, FR, DEC, NUM_FR, moneyFr, fmtMmFr, cname, localModel
  } = window.C2VLib;

  /* ------------------------------------------------- Coordonnees du client */
  const CONTACT_KEYS = ['company', 'first', 'last', 'phone', 'email'];
  const phoneDigits = v => String(v || '').replace(/\D/g, '');
  const CONTACT_OK = {
    // entreprise facultative (particuliers, associations sans raison sociale)
    company: () => true,
    first: v => /\p{L}/u.test(v),
    last: v => /\p{L}/u.test(v),
    // hors France : numeros nationaux plus courts (ex. Danemark, 8 chiffres)
    phone: v => /^\+?[\d\s().\/-]+$/.test(v) && phoneDigits(v).length >= (FR ? 9 : 8) && phoneDigits(v).length <= 15,
    email: v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)
  };
  // format international pour pre-remplir le paiement (sinon Shopify suppose un indicatif +1)
  const phoneE164 = v => {
    const raw = String(v || '').trim(), d = phoneDigits(raw);
    const out = raw.startsWith('+') ? '+' + d : d.startsWith('00') ? '+' + d.slice(2) : FR && d.length === 10 && d.startsWith('0') ? '+33' + d.slice(1) : '';
    return /^\+[1-9]\d{7,14}$/.test(out) ? out : '';
  };
  // partagees entre les studios d'une meme page (accueil : plusieurs produits),
  // et gardees le temps de la visite (produit suivant sur une autre page)
  const SHARED_CONTACT = {};
  const CONTACT_STORE = 'c2v-contact';
  try {
    const saved = JSON.parse(sessionStorage.getItem(CONTACT_STORE) || '{}') || {};
    CONTACT_KEYS.forEach(k => { if (typeof saved[k] === 'string' && saved[k]) SHARED_CONTACT[k] = saved[k]; });
  } catch (e) { /* stockage indisponible */ }
  const storeContact = () => { try { sessionStorage.setItem(CONTACT_STORE, JSON.stringify(SHARED_CONTACT)); } catch (e) { /* stockage indisponible */ } };
  // ligne du panier creee par le studio (propriete cachee _Studio)
  const isStudioLine = it => !!(it && it.properties && it.properties._Studio);

  /* --------------------------------------------------------- Roue couleur */
  class ColorPicker {
    constructor(root, onPick) {
      this.root = root; this.onPick = onPick;
      this.cv = $('.c2v-picker__wheel', root); this.wrap = $('.c2v-picker__wheel-wrap', root);
      this.knob = $('.c2v-picker__knob', root); this.val = $('.c2v-picker__val', root);
      this.hex = $('.c2v-picker__hex', root); this.prev = $('.c2v-picker__preview', root);
      this.h = 335; this.s = 0.8; this.v = 0.85; this.drawnV = -1; this.raf = 0;
      const pick = e => {
        const r = this.wrap.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        this.h = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360;
        this.s = clamp(Math.hypot(dx, dy) / (r.width / 2), 0, 1);
        this.place(); this.emit(true);
      };
      this.wrap.addEventListener('pointerdown', e => {
        e.preventDefault(); this.wrap.setPointerCapture(e.pointerId); pick(e);
        const mv = ev => pick(ev);
        const up = () => { this.wrap.removeEventListener('pointermove', mv); this.wrap.removeEventListener('pointerup', up); this.wrap.removeEventListener('pointercancel', up); };
        this.wrap.addEventListener('pointermove', mv); this.wrap.addEventListener('pointerup', up); this.wrap.addEventListener('pointercancel', up);
      });
      this.val.addEventListener('input', () => { this.v = this.val.value / 100; this.draw(); this.place(); this.emit(true); });
      this.hex.addEventListener('input', () => {
        const v = this.hex.value.trim();
        if (isHex(v)) { this.setHex(v.startsWith('#') ? v : '#' + v, true); this.emit(false); }
      });
      this.hex.addEventListener('blur', () => { this.hex.value = this.current(); });
    }
    current() { return rgbToHex(hsvToRgb(this.h, this.s, this.v)); }
    draw() {
      if (this.drawnV === this.v) return;
      this.drawnV = this.v;
      const c = this.cv, S = c.width, R = S / 2, cx = ctx2d(c), im = cx.createImageData(S, S), d = im.data;
      for (let y = 0; y < S; y++) for (let x = 0; x < S; x++) {
        const dx = x + 0.5 - R, dy = y + 0.5 - R, r = Math.hypot(dx, dy), p = (y * S + x) * 4;
        if (r > R) continue;
        const h = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360;
        const rgb = hsvToRgb(h, Math.min(1, r / (R - 1)), this.v);
        d[p] = rgb[0]; d[p + 1] = rgb[1]; d[p + 2] = rgb[2]; d[p + 3] = clamp((R - r) * 255, 0, 255);
      }
      cx.putImageData(im, 0, 0);
    }
    place() {
      const a = this.h * Math.PI / 180;
      this.knob.style.left = (50 + Math.cos(a) * this.s * 50) + '%';
      this.knob.style.top = (50 + Math.sin(a) * this.s * 50) + '%';
      const hex = this.current();
      this.knob.style.background = hex; this.prev.style.background = hex;
      this.val.style.setProperty('--hue', rgbToHex(hsvToRgb(this.h, this.s, 1)));
    }
    setHex(hex, keepInput) {
      const [h, s, v] = rgbToHsv(hexToRgb(hex));
      if (s > 0.001) this.h = h;
      this.s = s; this.v = Math.max(0.12, v);
      this.val.value = Math.round(this.v * 100);
      this.draw(); this.place();
      if (!keepInput) this.hex.value = hex.toUpperCase();
    }
    emit(syncInput) {
      const hex = this.current();
      if (syncInput && document.activeElement !== this.hex) this.hex.value = hex;
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => { this.raf = 0; this.onPick(this.hex === document.activeElement && isHex(this.hex.value) ? (this.hex.value.startsWith('#') ? this.hex.value : '#' + this.hex.value).toUpperCase() : this.current()); });
    }
    open(hex) { this.root.hidden = false; this.setHex(hex); requestAnimationFrame(() => this.root.classList.add('is-open')); }
    close() { this.root.classList.remove('is-open'); this.root.hidden = true; }
  }

  /* ---------------------------------------------------------------- Studio */
  class Studio {
    constructor(cfgEl) {
      this.cfg = readCfg(cfgEl);
      // modele du produit (metachamp studio.modele du produit miroir) : capote (rendu 3D) ou produit a plat
      this.model = this.cfg.model || { kind: 'capote' };
      this.flat = this.model.kind === 'flat';
      // couleur d'une partie du produit a plat (ex. bouchons d'oreille) : modele.colorStep
      const cs = this.model.colorStep;
      this.cs = this.flat && cs && Array.isArray(cs.colors) && cs.colors.length ? cs : null;
      this.subs = this.flat ? (this.cs ? ['plug', 'art', 'qty'] : ['art', 'qty']) : ['color', 'logo', 'pack', 'qty'];
      this.unit = this.model.unit || T('model.capote.unit', 'capotes de verre');
      // textes francais du modele (metachamp) : proprietes cachees, apercu joint, fiche client
      this.mfr = this.model.fr || this.model;
      this.csFr = this.cs ? (this.mfr.colorStep || this.cs) : null;
      this.unitFr = this.mfr.unit || 'capotes de verre';
      this.ft = this.flat ? flatTexts(this.model) : null;
      this.steps = this.cfg.steps.filter(s => s.qty >= this.cfg.minQty);
      if (!this.steps.length) this.steps = this.cfg.steps.slice(-1);
      this.extendSteps();
      this.st = {
        step: 1, sub: 0, seen: new Set([0]), maxStep: 1,
        sil: SILICONES[0], ink: this.flat ? ORIG_INK : INKS[1], inkAuto: !this.flat,
        logo: null, pack: null, art: null, qi: 0, orient: 'v',
        plug: this.cs ? (this.cs.colors.find(c => c.base) || this.cs.colors[0]) : null,
        company: '', first: '', last: '', phone: '', email: '', approve: false, view: '3d'
      };
      this.anim = { rgb: null, strength: 0, raf: 0 };
      this.slow = false;
      this.uploads = new Map();
      this.cartSig = '';
      const wrap = document.createElement('div');
      wrap.innerHTML = template(this.cfg).trim();
      this.el = wrap.firstElementChild;
      document.body.appendChild(this.el);
      this.q = s => $(s, this.el);
      this.qa = s => $$(s, this.el);
      this.cv3d = this.q('.c2v-cv--3d'); this.cvTop = this.q('.c2v-cv--top'); this.cvPack = this.q('.c2v-cv--pack');
      this.cvFlat = this.q('.c2v-cv--flat');
      this.stage = this.q('.c2v-stage');
      this.pickers = this.flat ? (this.ft.logo ? {
        ink: new ColorPicker(this.q('[data-picker="ink"]'), hex => this.setInk({ id: 'custom', name: 'Couleur sur mesure', hex }, false, true))
      } : {}) : {
        sil: new ColorPicker(this.q('[data-picker="sil"]'), hex => this.setSil({ id: 'custom', name: 'Couleur sur mesure', hex }, false)),
        ink: new ColorPicker(this.q('[data-picker="ink"]'), hex => this.setInk({ id: 'custom', name: 'Couleur sur mesure', hex }, false, true))
      };
      this.buildTicks();
      this.bind();
      this.refreshAll();
      if (this.flat) this.refreshFlatInk();
      if (this.cs) this.refreshPlug();
    }

    // Paliers au-dela de la derniere variante (jusqu'a data-max-qty) : prix unitaire du dernier palier, provisoire
    extendSteps() {
      const last = this.steps[this.steps.length - 1], max = this.cfg.maxQty, inc = this.cfg.extStep;
      if (!last || !(max > last.qty) || !(inc > 0)) return;
      const unit = last.ttc / last.qty;
      for (let q = last.qty + inc; q <= max; q += inc) this.steps.push({ id: null, qty: q, ttc: Math.round(q * unit * 100) / 100, ext: true });
    }

    /* ---------- ouverture / fermeture */
    preload() {
      if (this.readyP) return this.readyP;
      const im = this.cfg.images;
      if (this.flat) {
        this.readyP = loadStudioImage('flat', im.flat).then(img => {
          this.fv = new FlatView(img, this.model);
          if (this.cs) this.fv.setTint(this.plugTint());
          this.cvFlat.width = this.fv.W; this.cvFlat.height = this.fv.H; this.cFlat = ctx2d(this.cvFlat);
          this.renderFlat();
          this.stage.classList.add('is-ready');
        }).catch(err => this.loadFailed(err));
        return this.readyP;
      }
      this.readyP = Promise.all([
        loadStudioImage('3d', im['3d']).then(img => { this.lid = new Lid3D(img); this.cv3d.width = this.lid.W; this.cv3d.height = this.lid.H; this.c3d = ctx2d(this.cv3d); }),
        loadStudioImage('top', im.top).then(img => { this.topv = new TopView(img); this.cvTop.width = this.topv.W; this.cvTop.height = this.topv.H; this.cTop = ctx2d(this.cvTop); }),
        loadStudioImage('pack', im.pack).then(img => { this.pk = new Pack(img); this.cvPack.width = this.pk.W; this.cvPack.height = this.pk.H; this.cPack = ctx2d(this.cvPack); })
      ]).then(() => {
        const t0 = performance.now();
        this.renderViews(true);
        this.slow = performance.now() - t0 > 45;
        if (this.st.pack) this.pk.setVisual(this.st.pack.canvas);
        this.pk.render(this.cPack);
        this.stage.classList.add('is-ready');
      }).catch(err => this.loadFailed(err));
      return this.readyP;
    }
    loadFailed(err) {
      this.readyP = null;
      this.stage.classList.add('is-error');
      const l = this.q('.c2v-loading span:last-child');
      if (l) l.textContent = T('studio.load_failed', "L'aperçu n'a pas pu se charger. Rechargez la page pour réessayer.");
      console.warn('[C2V Studio]', err);
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.syncFromPage();
      this.el.hidden = false;
      document.documentElement.classList.add('c2v-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => this.el.classList.add('is-open')));
      this.preload();
      this.refreshAll();
      setTimeout(() => { const f = this.q('.c2v-close'); if (f) f.focus({ preventScroll: true }); }, 60);
    }
    close() {
      this.el.classList.remove('is-open');
      document.documentElement.classList.remove('c2v-lock');
      const done = () => { this.el.hidden = true; };
      if (reduceMotion()) done(); else setTimeout(done, 380);
      this.pushToPage(true);
      if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
    }

    /* ---------- evenements */
    bind() {
      const el = this.el;
      el.addEventListener('click', e => {
        const t = e.target.closest('button, [data-c2v-close], a[data-c2v-another-other]');
        if (!t || !el.contains(t)) return;
        if (t.hasAttribute('data-c2v-close')) { this.close(); return; }
        if (t.hasAttribute('data-c2v-another')) { this.another(t); return; }
        if (t.hasAttribute('data-c2v-another-same')) { this.anotherSame(); return; }
        if (t.hasAttribute('data-c2v-another-other')) { e.preventDefault(); this.anotherOther(t.href); return; }
        if (t.hasAttribute('data-c2v-rmline')) { this.removeLine(t.dataset.c2vRmline, t); return; }
        if (t.hasAttribute('data-c2v-switch')) { this.close(); document.dispatchEvent(new CustomEvent('c2v:switch', { detail: { key: this.cfg.key } })); return; }
        if (t.matches('[data-grp]')) { this.onSwatch(t); return; }
        if (t.matches('.c2v-rail__i')) { this.goSub(+t.dataset.sub); return; }
        if (t.matches('.c2v-steps__i')) { const s = +t.dataset.step; if (s <= this.st.maxStep) this.goStep(s); return; }
        if (t.matches('[data-orient]')) { this.setOrient(t.dataset.orient); return; }
        if (t.matches('.c2v-views__b')) { this.setView(t.dataset.view); return; }
        if (t.matches('[data-qty]')) { this.setQi(this.st.qi + (+t.dataset.qty), true); return; }
        if (t.matches('[data-c2v-next]')) { this.next(); return; }
        if (t.matches('[data-c2v-prev]')) { this.prev(); return; }
        if (t.matches('[data-to]')) { this.setQty(+t.dataset.to, true); return; }
        if (t.matches('[data-remove]')) { this.removeFile(t.dataset.remove); return; }
        if (t.matches('[data-goto]')) { const [s, sub] = t.dataset.goto.split(':').map(Number); this.goStep(s); if (s === 1) this.goSub(sub); }
      });
      el.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); this.close(); }
        if (e.key === 'Tab') this.trap(e);
      });
      // fichiers
      this.qa('.c2v-drop').forEach(d => {
        const kind = d.dataset.drop, input = $('input', d);
        input.addEventListener('change', () => { if (input.files[0]) this.onFile(kind, input.files[0]); input.value = ''; });
        ['dragenter', 'dragover'].forEach(ev => d.addEventListener(ev, e => { e.preventDefault(); d.classList.add('is-drag'); }));
        ['dragleave', 'dragend'].forEach(ev => d.addEventListener(ev, () => d.classList.remove('is-drag')));
        d.addEventListener('drop', e => { e.preventDefault(); d.classList.remove('is-drag'); const f = e.dataTransfer && e.dataTransfer.files[0]; if (f) this.onFile(kind, f); });
      });
      // quantite
      // curseur proportionnel a la quantite (5 000 au milieu d'une jauge qui va jusqu'a 10 000), aimante sur les paliers
      this.range = this.q('.c2v-range__input');
      this.range.min = '0'; this.range.max = '1000'; this.range.step = '1';
      this.range.addEventListener('input', () => this.setQi(this.nearestQi(this.qFromFrac(+this.range.value / 1000)), false));
      // clavier : un palier par touche
      this.range.addEventListener('keydown', e => {
        const k = e.key, last = this.steps.length - 1, qi = this.st.qi;
        const to = k === 'ArrowRight' || k === 'ArrowUp' ? qi + 1 : k === 'ArrowLeft' || k === 'ArrowDown' ? qi - 1
          : k === 'PageUp' ? qi + 4 : k === 'PageDown' ? qi - 4 : k === 'Home' ? 0 : k === 'End' ? last : null;
        if (to === null) return;
        e.preventDefault();
        this.setQi(to, false);
      });
      this.range.addEventListener('change', () => this.pushToPage(true));
      // coordonnees
      this.qa('[data-c2v-f]').forEach(inp => {
        const k = inp.dataset.c2vF;
        inp.addEventListener('input', () => {
          this.st[k] = inp.value.trim(); SHARED_CONTACT[k] = this.st[k]; storeContact();
          this.fieldErr(k, false); this.refreshFoot();
        });
        inp.addEventListener('blur', () => { this.fieldErr(k, !!this.st[k] && !this.fieldOk(k)); });
      });
      const ap = this.q('[data-c2v-approve]');
      ap.addEventListener('change', () => { this.st.approve = ap.checked; this.refreshFoot(); });
      // parallaxe douce sur la scene
      const scene = this.q('.c2v-scene');
      this.stage.addEventListener('pointermove', e => {
        if (reduceMotion() || e.pointerType !== 'mouse') return;
        const r = this.stage.getBoundingClientRect();
        scene.style.setProperty('--rx', (((e.clientY - r.top) / r.height - 0.5) * -6).toFixed(2) + 'deg');
        scene.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 8).toFixed(2) + 'deg');
      });
      this.stage.addEventListener('pointerleave', () => { scene.style.setProperty('--rx', '0deg'); scene.style.setProperty('--ry', '0deg'); });
    }
    trap(e) {
      const f = this.qa('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])').filter(x => x.offsetParent !== null && !x.closest('[hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- couleurs */
    onSwatch(b) {
      const grp = b.dataset.grp, i = b.dataset.i, pk = this.pickers[grp];
      if (grp === 'plug') { if (this.cs && this.cs.colors[+i]) this.setPlug(this.cs.colors[+i]); return; }
      if (i === 'custom') {
        const isOpen = !pk.root.hidden;
        if (isOpen) { pk.close(); b.setAttribute('aria-expanded', 'false'); return; }
        const cur = grp === 'sil' ? (this.st.sil.hex || '#D6246E') : (this.st.ink.hex || '#111111');
        pk.open(cur); b.setAttribute('aria-expanded', 'true');
        if (grp === 'sil') this.setSil({ id: 'custom', name: 'Couleur sur mesure', hex: pk.current() }, true);
        else this.setInk({ id: 'custom', name: 'Couleur sur mesure', hex: pk.current() }, true, true);
        return;
      }
      pk.close();
      const plus = this.q(`[data-grp="${grp}"][data-i="custom"]`); if (plus) plus.setAttribute('aria-expanded', 'false');
      if (grp === 'sil') this.setSil(SILICONES[+i], true);
      else this.setInk(i === 'orig' ? ORIG_INK : INKS[+i], true, true);
    }
    // couleur de la partie teintee (bouchons) : la photo d'origine pour la teinte de base
    plugTint() { const c = this.st.plug; return !c || c.base ? null : c.hex; }
    // fr : nom francais (proprietes cachees, fiche client), sinon nom traduit
    plugLabel(fr) { const c = this.st.plug; return c ? `${fr ? c.name : cname(c)} (${c.hex})` : ''; }
    setPlug(c) {
      this.st.plug = c;
      if (this.fv) { this.fv.setTint(this.plugTint()); this.renderFlat(); }
      this.refreshPlug();
    }
    refreshPlug() {
      const c = this.st.plug;
      if (!this.cs || !c) return;
      this.qa('[data-grp="plug"]').forEach(b => b.setAttribute('aria-pressed', this.cs.colors[+b.dataset.i] === c ? 'true' : 'false'));
      const picked = this.q('[data-picked="plug"]');
      if (picked) picked.innerHTML = `<span>${esc(cname(c))}</span><code>${esc(c.hex)}</code>`;
      const chip = this.q('[data-chip="plug"]');
      if (chip) { chip.style.setProperty('--c', c.hex); chip.lastChild.textContent = T('common.label_value', '{label} : {value}', { label: this.cs.chip || T('studio.color', 'Couleur'), value: cname(c).toLowerCase() }); }
    }
    setSil(c, animate) {
      this.st.sil = c;
      if (this.st.inkAuto) this.st.ink = this.autoInk();
      this.refreshColors();
      this.renderViews(animate);
    }
    setInk(c, animate, manual) {
      this.st.ink = c;
      if (manual) this.st.inkAuto = false;
      if (this.flat) { this.refreshFlatInk(); this.refreshFileCard('art'); this.renderFlat(); return; }
      this.refreshColors();
      this.renderViews(false);
    }
    autoInk() {
      const ref = hexToRgb(this.st.sil.hex || NATUREL_REF);
      return relLum(ref) < 0.4 ? INKS[0] : INKS[1];
    }
    silRgbRef() { return hexToRgb(this.st.sil.hex || NATUREL_REF); }

    /* ---------- rendu */
    // Orientation de l'impression (sifflet, modele.orient) : verticale par defaut, ou horizontale
    horiz() { return !!(this.model.orient && this.st.orient === 'h'); }
    // format d'impression tel qu'il se lit (largeur, hauteur) : inverse en horizontal
    printMm() { const mm = this.model.mm || [50, 50]; return this.horiz() ? [mm[1], mm[0]] : [mm[0], mm[1]]; }
    renderFlat(noEmpty) {
      if (!this.fv) return;
      const font = getComputedStyle(this.el).getPropertyValue('--c2v-body').trim() || 'sans-serif';
      const [pw, ph] = this.printMm();
      const empty = noEmpty ? null : Object.assign({ font }, this.ft.empty, { sub: `${fmtMm(pw)} × ${fmtMm(ph)} mm` });
      const fv = this.fv, W = fv.W, H = fv.H, cv = this.cvFlat;
      if (!this.horiz()) {
        if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
        fv.render(this.cFlat, this.printArt(), empty);
        return;
      }
      // horizontal : rendu dans le sens du produit, puis quart de tour a gauche pour l'affichage
      if (!this.cvUp) { this.cvUp = makeCanvas(W, H); this.cUp = ctx2d(this.cvUp); }
      fv.render(this.cUp, this.printArt(), null);
      if (cv.width !== H || cv.height !== W) { cv.width = H; cv.height = W; }
      const c = this.cFlat;
      c.save(); c.clearRect(0, 0, H, W); c.translate(0, W); c.rotate(-Math.PI / 2); c.drawImage(this.cvUp, 0, 0); c.restore();
      if (empty && !this.st.art) {
        const b = fv.box;
        fv.drawEmpty(c, { x: b.y, y: W - b.x - b.w, w: b.h, h: b.w }, empty, H, W);
      }
    }
    setOrient(o) {
      if (!this.model.orient || (o !== 'v' && o !== 'h') || o === this.st.orient) return;
      this.st.orient = o;
      this.qa('[data-orient]').forEach(b => { const on = b.dataset.orient === o; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      const [pw, ph] = this.printMm();
      const set = (sel, v) => { const e = this.q(sel); if (e) e.textContent = v; };
      set('[data-c2v-fmt]', `${fmtMm(pw / 10)} × ${fmtMm(ph / 10)} cm`);
      set('[data-c2v-mm]', `${fmtMm(pw)} × ${fmtMm(ph)}`);
      set('[data-c2v-px]', `${NUM.format(px300(pw))} × ${NUM.format(px300(ph))} px`);
      const flt = this.q('.c2v-flat');
      if (flt && !reduceMotion()) { flt.classList.remove('is-turn-h', 'is-turn-v'); void flt.offsetWidth; flt.classList.add(o === 'h' ? 'is-turn-h' : 'is-turn-v'); }
      // le fichier est relu pour recalculer la taille et la resolution dans la nouvelle orientation
      if (this.st.art && this.st.art.file && this.st.art.mode === 'logo') this.onFile('art', this.st.art.file);
      else { this.renderFlat(); this.refreshAll(); }
    }
    // Fichier tel qu'il sera imprime : logo d'origine, ou converti en une seule couleur
    mono() { return this.flat && this.ft.logo && !!this.st.ink.hex && this.st.art && this.st.art.mode === 'logo'; }
    printCanvas() {
      const a = this.st.art;
      if (!a) return null;
      if (!this.mono()) return a.canvas;
      const key = this.st.ink.hex;
      if (!a.monoCache || a.monoCache.key !== key) a.monoCache = { key, canvas: monoLogo(a.canvas, key, a.white) };
      return a.monoCache.canvas;
    }
    printArt() {
      const a = this.st.art;
      if (!a) return null;
      let canvas = this.printCanvas();
      if (this.horiz() && a.mode === 'logo') {
        if (!a.turnCache || a.turnCache.src !== canvas) a.turnCache = { src: canvas, canvas: rotate90(canvas) };
        canvas = a.turnCache.canvas;
      }
      return { mode: a.mode, canvas };
    }
    printThumb() {
      const a = this.st.art;
      if (!a) return '';
      if (a.mode !== 'logo') return a.thumb.toDataURL('image/png');
      return artThumb(this.printCanvas(), clamp(a.w / a.h, 0.8, 2), '#F3F3F3').toDataURL('image/png');
    }
    // Pastilles de couleur du logo (produits a plat) : couleurs d'origine par defaut, une seule couleur au choix
    refreshFlatInk() {
      if (!this.ft.logo) return;
      const ink = this.st.ink;
      this.qa('[data-grp="ink"]').forEach(b => {
        const i = b.dataset.i;
        const on = i === 'orig' ? ink.id === 'orig' : i === 'custom' ? ink.id === 'custom' : INKS[+i] && INKS[+i].id === ink.id;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (i === 'custom') { b.style.setProperty('--sw', ink.id === 'custom' ? ink.hex : 'transparent'); b.classList.toggle('is-set', ink.id === 'custom'); }
      });
      this.q('[data-picked="ink"]').innerHTML = ink.hex
        ? `<span>${esc(cname(ink))}</span><code>${ink.hex}</code><em>${T('studio.picked_mono', 'impression 1 couleur')}</em>`
        : `<span>${esc(cname(ink))}</span><code>${T('studio.picked_orig', "logo imprimé tel qu'importé")}</code>`;
      const chip = this.q('[data-chip="print"]');
      if (chip) {
        const dot = $('.c2v-chip__dot', chip);
        dot.classList.toggle('c2v-chip__dot--cmyk', !ink.hex);
        dot.style.setProperty('--c', ink.hex || '');
        if (!ink.hex) dot.style.removeProperty('--c');
        chip.lastChild.textContent = ink.hex ? (this.model.relief ? T('studio.chip_mono_relief', 'Impression 1 couleur en relief') : T('studio.chip_mono', 'Impression 1 couleur')) : this.ft.print;
      }
      const box = this.q('[data-notes="ink"]');
      box.innerHTML = '';
      const add = (level, text) => {
        const n = document.createElement('p');
        n.className = 'c2v-note c2v-note--' + level;
        n.innerHTML = (level === 'warn' ? I.alert : I.info) + '<span></span>';
        n.lastChild.textContent = text;
        box.appendChild(n);
      };
      if (ink.hex && contrast(hexToRgb(ink.hex), [255, 255, 255]) < 1.6) add('warn', T('studio.warn_contrast_surface', 'Contraste faible : cette couleur sera peu visible sur {surface}, qui est blanc.', { surface: this.ft.surface }));
      if (ink.hex && this.st.art && this.st.art.multi) add('info', T('studio.note_multi_flat', 'Votre logo contient plusieurs couleurs : il est imprimé en aplat de la couleur choisie.'));
    }
    renderViews(animate) {
      if (this.flat) { this.renderFlat(); return; }
      // les 2 vues (3D et dessus) doivent etre chargees
      if (!this.lid || !this.topv) return;
      const target = this.st.sil.hex ? hexToRgb(this.st.sil.hex) : null;
      const tStr = target ? 1 : 0;
      const a = this.anim;
      const from = { rgb: a.rgb ? a.rgb.slice() : (target ? target.slice() : [255, 255, 255]), strength: a.strength };
      const to = { rgb: target || from.rgb, strength: tStr };
      cancelAnimationFrame(a.raf);
      const zone = this.st.logo ? this.st.logo.zone : null, ink = hexToRgb(this.st.ink.hex);
      const draw = (rgb, s, both) => {
        a.rgb = rgb; a.strength = s;
        if (both || this.st.view === '3d') this.lid.render(this.c3d, rgb, s * 0.92, zone, ink);
        if (both || this.st.view === 'top') this.topv.render(this.cTop, rgb, s * 0.92, zone, ink);
      };
      if (!animate || this.slow || reduceMotion()) { draw(to.rgb, to.strength, true); return; }
      const t0 = performance.now(), dur = 320;
      const ease = t => 1 - Math.pow(1 - t, 3);
      const step = now => {
        const t = clamp((now - t0) / dur, 0, 1), e = ease(t);
        const rgb = from.rgb.map((v, k) => v + (to.rgb[k] - v) * e);
        const s = from.strength + (to.strength - from.strength) * e;
        draw(rgb, s, t >= 1);
        if (t < 1) a.raf = requestAnimationFrame(step);
      };
      a.raf = requestAnimationFrame(step);
    }
    setView(v) {
      this.st.view = v;
      this.stage.dataset.view = v;
      this.qa('.c2v-views__b').forEach(b => b.classList.toggle('is-active', b.dataset.view === v));
    }

    /* ---------- fichiers */
    async onFile(kind, file, opts) {
      const notes = this.q(`[data-notes="${kind}"]`);
      const drop = this.q(`[data-drop="${kind}"]`);
      notes.innerHTML = '';
      if (file.size > MAX_FILE) { this.note(kind, 'error', T('common.file_too_big', 'Fichier trop lourd ({size} Mo). Maximum {max} Mo.', { size: (file.size / 1048576).toFixed(1).replace('.', FR ? '.' : DEC), max: Math.round(MAX_FILE / 1048576) })); return; }
      const type = fileKind(file);
      drop.classList.add('is-busy');
      try {
        // copie en memoire : le fichier reste disponible pour l'envoi au panier
        file = new File([await file.arrayBuffer()], file.name, { type: file.type, lastModified: file.lastModified });
        if (kind === 'logo') await this.loadLogo(file, type);
        else if (kind === 'art') await this.loadArt(file, type, opts);
        else await this.loadPack(file, type);
      } catch (err) {
        console.warn('[C2V Studio]', err);
        const pdfFail = String(err && err.message) === 'pdfjs';
        this.note(kind, 'error', pdfFail ? T('common.pdf_failed', "Le lecteur PDF n'a pas pu se charger. Vérifiez votre connexion puis réessayez.") : T('common.read_failed', "Ce fichier n'a pas pu être lu. Essayez un autre format ({formats}).", { formats: kind === 'art' && !this.ft.logo ? T('common.formats_visual', 'PDF, PNG ou JPG') : T('common.formats_logo', 'PNG, SVG ou PDF') }));
      } finally {
        drop.classList.remove('is-busy');
      }
    }
    async loadLogo(file, type) {
      if (!type) { this.note('logo', 'error', T('common.format_unsupported', 'Format non pris en charge. Importez un PNG, JPG, SVG ou PDF.')); return; }
      let src, vector = false;
      if (type === 'raster') src = await rasterSource(file);
      else if (type === 'svg') { src = await svgSource(file); vector = true; }
      else { const r = await renderPdf(file, 2000, 'rgba(0,0,0,0)'); src = { src: r.canvas, w: r.canvas.width, h: r.canvas.height }; vector = true; }
      const an = analyzeLogo(src.src, src.w, src.h);
      if (an.empty) { this.note('logo', 'error', T('common.no_motif', "Aucun motif n'a été détecté dans ce fichier. Vérifiez que le logo n'est pas blanc sur fond blanc.")); return; }
      const bw = (an.bbox[2] - an.bbox[0] + 1) / an.k, bh = (an.bbox[3] - an.bbox[1] + 1) / an.k;
      if (!vector && bw < ZONE_W && bh < ZONE_H) {
        this.note('logo', 'error', T('studio.err_logo_small', 'Logo trop petit ({w} × {h} px utiles). Il doit atteindre au moins 639 px de large ou 429 px de haut pour une impression nette. Importez une version plus grande ou un fichier vectoriel (SVG ou PDF).', { w: Math.round(bw), h: Math.round(bh) }));
        return;
      }
      const zone = buildZone(an);
      const ratio = bw / bh;
      this.st.logo = { name: file.name, file, type, vector, w: Math.round(bw), h: Math.round(bh), ratio, multi: an.multi, zone };
      if (an.multi) this.note('logo', 'warn', T('studio.warn_multi', "Votre logo contient plusieurs couleurs. L'impression se fait en une seule couleur : il a été converti en aplat. Choisissez sa couleur d'impression ci-dessous."));
      if (Math.abs(ratio - ZONE_RATIO) / ZONE_RATIO > 0.15) this.note('logo', 'info', T('studio.note_ratio', 'Ratio de votre logo {ratio}:1. Il est ajusté sans déformation dans la zone 1,49:1. Pour occuper toute la zone, préférez un format 1,49:1.', { ratio: ratio.toFixed(2).replace('.', DEC) }));
      if (an.cov > 0.85) this.note('logo', 'warn', T('studio.warn_cov', 'Le logo semble occuper tout le fichier. Si un fond est présent, un fichier à fond transparent donnera un meilleur résultat.'));
      if (!an.multi) this.note('logo', 'ok', vector ? T('studio.ok_vector', "Fichier vectoriel : qualité d'impression optimale.") : T('studio.ok_logo', "Logo prêt pour l'impression."));
      this.setView('3d');
      this.refreshAll();
      this.renderViews(false);
      this.pulse('.c2v-product');
    }
    // Emballage de la capote (70 x 90 mm, portrait) : PDF, PNG, JPG ou SVG, comme le logo.
    // Visuel imprime tel quel (couleurs d'origine, pas de couleur d'impression), place sur fond blanc
    // et redimensionne sans deformation au format de l'emballage s'il n'y est pas deja.
    async loadPack(file, type) {
      if (!type) { this.note('pack', 'error', T('common.format_unsupported', 'Format non pris en charge. Importez un PNG, JPG, SVG ou PDF.')); return; }
      const Wmm = 70, Hmm = 90, fmt = `${fmtMm(Wmm)} × ${fmtMm(Hmm)} mm`, need = `${NUM.format(px300(Wmm))} × ${NUM.format(px300(Hmm))} px`;
      let canvas, wmm = 0, hmm = 0, wpx = 0, hpx = 0, pages = 1;
      if (type === 'pdf') {
        const r = await renderPdf(file, 1100, 'rgb(255,255,255)');
        canvas = r.canvas; wmm = r.wPt * 25.4 / 72; hmm = r.hPt * 25.4 / 72; pages = r.pages;
      } else {
        const src = type === 'svg' ? await svgSource(file) : await rasterSource(file);
        if (type === 'raster') { wpx = src.w; hpx = src.h; }
        canvas = flattenVisual(src.src, src.w, src.h, 1100);
      }
      // resolution une fois mis au format (image seulement : PDF et SVG restent nets)
      const dpi = type === 'raster' ? Math.round(25.4 * Math.max(wpx / Wmm, hpx / Hmm)) : 0;
      if (type === 'raster' && dpi < 150) {
        this.note('pack', 'error', T('studio.err_image_small', 'Image trop petite ({w} × {h} px) : environ {dpi} dpi une fois imprimée en {fmt}. Il faut au moins {need} (300 dpi), ou un PDF.', { w: NUM.format(wpx), h: NUM.format(hpx), dpi, fmt, need }));
        return;
      }
      const thumb = makeCanvas(84, 108), tc = ctx2d(thumb);
      tc.fillStyle = '#fff'; tc.fillRect(0, 0, 84, 108);
      const k = Math.min(84 / canvas.width, 108 / canvas.height);
      tc.imageSmoothingQuality = 'high';
      tc.drawImage(canvas, (84 - canvas.width * k) / 2, (108 - canvas.height * k) / 2, canvas.width * k, canvas.height * k);
      this.st.pack = { name: file.name, file, type, vector: type !== 'raster', canvas, thumb, wmm, hmm, wpx, hpx, dpi, pages };
      const ratioOff = Math.abs((canvas.width / canvas.height) / (Wmm / Hmm) - 1) > 0.03;
      if (ratioOff) this.note('pack', 'warn', T('studio.warn_ratio', 'Proportions différentes du format {fmt} : le visuel est ajusté sans déformation, des bandes blanches peuvent apparaître.', { fmt }));
      else if (type === 'pdf' && (Math.abs(wmm - Wmm) > 2 || Math.abs(hmm - Hmm) > 2)) this.note('pack', 'ok', T('studio.ok_pack_scaled', "Format {w} × {h} mm, aux proportions 70 × 90 mm : il sera mis à l'échelle.", { w: Math.round(wmm), h: Math.round(hmm) }));
      else if (type === 'pdf') this.note('pack', 'ok', T('studio.ok_pack', 'Format 70 × 90 mm conforme.'));
      if (type === 'raster' && dpi < 300) this.note('pack', 'warn', T('studio.warn_dpi_visual', 'Résolution un peu juste (environ {dpi} dpi). Pour une impression nette, visez {need} (300 dpi) ou un PDF.', { dpi, need }));
      else if (type === 'raster' && !ratioOff) this.note('pack', 'ok', T('studio.ok_image_hd', "Image haute définition ({dpi} dpi), prête pour l'impression.", { dpi }));
      if (type === 'svg') this.note('pack', 'ok', T('studio.ok_vector', "Fichier vectoriel : qualité d'impression optimale."));
      if (pages > 1) this.note('pack', 'info', T('studio.note_pages', 'Votre PDF contient {pages} pages : seule la page 1 (recto) est utilisée.', { pages }));
      if (this.pk) { this.pk.setVisual(canvas); this.pk.render(this.cPack); }
      this.refreshAll();
      this.pulse('.c2v-pack');
    }
    // format du visuel d'emballage (fiche du fichier, recapitulatif)
    packMeta(f) {
      if (f.type === 'pdf') return `PDF · ${Math.round(f.wmm)} × ${Math.round(f.hmm)} mm`;
      if (f.type === 'svg') return `${T('studio.meta_vector', 'Vectoriel')} · SVG`;
      return `${(f.name.split('.').pop() || '').toUpperCase()} · ${NUM.format(f.wpx)} × ${NUM.format(f.hpx)} px · ${f.dpi} dpi`;
    }
    // Produits a plat : logo couleur (fond retire) ou visuel du sachet (PDF, PNG, JPG)
    async loadArt(file, type, opts) {
      const m = this.model, t = this.ft, [Wmm, Hmm] = t.logo ? this.printMm() : m.mm, need = `${NUM.format(px300(Wmm))} × ${NUM.format(px300(Hmm))} px`;
      const fmt = `${fmtMm(Wmm)} × ${fmtMm(Hmm)} mm`, zr = Wmm / Hmm;
      const dpiOf = (w, h) => Math.round(25.4 * Math.max(w / Wmm, h / Hmm));
      let art;
      if (!t.logo && opts && opts.asLogo) {
        // logo depose sur la page d'accueil, pour un produit a visuel : centre sur fond blanc au format du sachet
        if (!type) { this.note('art', 'error', T('common.format_unsupported', 'Format non pris en charge. Importez un PNG, JPG, SVG ou PDF.')); return; }
        let src, vector = false;
        if (type === 'raster') src = await rasterSource(file);
        else if (type === 'svg') { src = await svgSource(file); vector = true; }
        else { const r = await renderPdf(file, 2000, 'rgba(0,0,0,0)'); src = { src: r.canvas, w: r.canvas.width, h: r.canvas.height }; vector = true; }
        const lg = colorLogo(src.src, src.w, src.h);
        if (lg.empty) { this.note('art', 'error', T('common.no_motif', "Aucun motif n'a été détecté dans ce fichier. Vérifiez que le logo n'est pas blanc sur fond blanc.")); return; }
        const lw = logoOnWhite(lg.canvas, m.mm, 1800);
        const w = Math.round(lg.bw), h = Math.round(lg.bh);
        const placedW = lg.canvas.width * lw.mmPerPx, placedH = lg.canvas.height * lw.mmPerPx;
        const dpi = Math.round(25.4 * lg.bw / placedW);
        const placed = `${fmtMm(placedW)} × ${fmtMm(placedH)} mm`;
        if (!vector && dpi < 150) {
          this.note('art', 'error', T('studio.err_logo_small_visual', 'Logo trop petit ({w} × {h} px utiles) : environ {dpi} dpi une fois imprimé en {size}. Importez une version plus grande, un fichier vectoriel (SVG, PDF) ou le visuel complet du sachet.', { w: NUM.format(w), h: NUM.format(h), dpi, size: placed }));
          return;
        }
        art = { mode: 'visuel', fromLogo: true, name: file.name, file, type, vector, canvas: lw.canvas, wmm: 0, hmm: 0, wpx: w, hpx: h, dpi: vector ? 0 : dpi, pages: 1, rotated: false, thumb: artThumb(lw.canvas, zr) };
        this.st.art = art;
        this.note('art', 'info', T('studio.note_centered', "Votre logo est centré sur fond blanc pour l'aperçu du sachet. Pour un sachet entièrement à vos couleurs, importez plutôt son visuel complet (PDF, PNG ou JPG, {fmt}).", { fmt }));
        if (lg.white) this.note('art', 'warn', T('studio.warn_white_visual', 'Votre logo est blanc ou très clair : il sera peu visible sur {surface}, qui est blanc. Importez plutôt une version colorée ou foncée.', { surface: t.surface }));
        if (!vector && dpi < 300) this.note('art', 'warn', T('studio.warn_dpi_bigger', "Résolution un peu juste (environ {dpi} dpi à la taille d'impression). Pour une impression nette, importez une version plus grande ou un fichier vectoriel.", { dpi }));
        if (vector) this.note('art', 'ok', T('studio.ok_vector', "Fichier vectoriel : qualité d'impression optimale."));
        else if (dpi >= 300) this.note('art', 'ok', T('studio.ok_logo_dpi', "Logo prêt pour l'impression ({dpi} dpi).", { dpi }));
        this.refreshAll();
        this.refreshFlatInk();
        this.renderFlat();
        this.pulse('.c2v-flat');
        return;
      }
      if (t.logo) {
        if (!type) { this.note('art', 'error', T('common.format_unsupported', 'Format non pris en charge. Importez un PNG, JPG, SVG ou PDF.')); return; }
        let src, vector = false;
        if (type === 'raster') src = await rasterSource(file);
        else if (type === 'svg') { src = await svgSource(file); vector = true; }
        else { const r = await renderPdf(file, 2000, 'rgba(0,0,0,0)'); src = { src: r.canvas, w: r.canvas.width, h: r.canvas.height }; vector = true; }
        const lg = colorLogo(src.src, src.w, src.h);
        if (lg.empty) { this.note('art', 'error', T('common.no_motif', "Aucun motif n'a été détecté dans ce fichier. Vérifiez que le logo n'est pas blanc sur fond blanc.")); return; }
        const w = Math.round(lg.bw), h = Math.round(lg.bh), dpi = dpiOf(lg.bw, lg.bh);
        if (!vector && dpi < 150) {
          this.note('art', 'error', T('studio.err_logo_small_flat', 'Logo trop petit ({w} × {h} px utiles) : environ {dpi} dpi une fois imprimé en {size}. Il faut au moins {need} (300 dpi) ou un fichier vectoriel (SVG, PDF).', { w: NUM.format(w), h: NUM.format(h), dpi, size: fmt, need }));
          return;
        }
        art = { mode: 'logo', name: file.name, file, type, vector, w, h, dpi, canvas: lg.canvas, white: lg.white, multi: lg.multi, thumb: artThumb(lg.canvas, clamp(lg.bw / lg.bh, 0.8, 2), '#F3F3F3') };
        this.st.art = art;
        if (lg.white) this.note('art', 'warn', T('studio.warn_white_logo', "Votre logo est blanc ou très clair : il sera peu visible sur {surface}, qui est blanc. Importez plutôt une version colorée ou foncée, ou choisissez une couleur d'impression ci-dessous.", { surface: t.surface }));
        if (!vector && dpi < 300) this.note('art', 'warn', T('studio.warn_dpi_need', "Résolution un peu juste (environ {dpi} dpi à la taille d'impression). Pour une impression nette, importez au moins {need} ou un fichier vectoriel.", { dpi, need }));
        if (lg.cov > 0.85) this.note('art', 'warn', T('studio.warn_cov', 'Le logo semble occuper tout le fichier. Si un fond est présent, un fichier à fond transparent donnera un meilleur résultat.'));
        const ratio = lg.bw / lg.bh;
        if (Math.abs(ratio - zr) / zr > 0.2) this.note('art', 'info', T('studio.note_fit_zone', "Votre logo est ajusté sans déformation dans la zone d'impression {fmt}.", { fmt }));
        if (m.orient && !this.horiz() && ratio > 1.3) this.note('art', 'info', T('studio.note_horizontal', "Votre logo est plutôt horizontal : choisissez l'impression horizontale (au-dessus du sifflet) pour l'imprimer plus grand."));
        if (vector) this.note('art', 'ok', T('studio.ok_vector', "Fichier vectoriel : qualité d'impression optimale."));
        else if (dpi >= 300) this.note('art', 'ok', T('studio.ok_logo_colors', "Logo prêt pour l'impression en couleurs ({dpi} dpi).", { dpi }));
      } else {
        if (type !== 'pdf' && type !== 'raster') { this.note('art', 'error', T('studio.err_format_visual', 'Format non pris en charge. Importez un PDF, un PNG ou un JPG.')); return; }
        let canvas, wmm = 0, hmm = 0, wpx = 0, hpx = 0, pages = 1;
        if (type === 'pdf') {
          const r = await renderPdf(file, 1800, 'rgb(255,255,255)');
          canvas = r.canvas; wmm = r.wPt * 25.4 / 72; hmm = r.hPt * 25.4 / 72; pages = r.pages;
        } else {
          const src = await rasterSource(file);
          wpx = src.w; hpx = src.h;
          canvas = flattenVisual(src.src, src.w, src.h, 1800);
        }
        // fichier dans l'autre sens que le sachet : quart de tour pour l'apercu
        let rotated = false;
        const fr = canvas.width / canvas.height;
        if (Math.abs(Math.log(zr)) > 0.15 && Math.abs(Math.log(fr)) > 0.15 && (zr > 1) !== (fr > 1)) {
          canvas = rotate90(canvas); rotated = true;
          [wmm, hmm] = [hmm, wmm]; [wpx, hpx] = [hpx, wpx];
        }
        const ratioOff = Math.abs((canvas.width / canvas.height) / zr - 1) > 0.04;
        if (type === 'pdf') {
          if (wmm < Wmm - 2 || hmm < Hmm - 2) {
            this.note('art', 'error', T('studio.err_visual_small', 'Format trop petit ({w} × {h} mm). Le visuel doit faire au moins {fmt}.', { w: Math.round(wmm), h: Math.round(hmm), fmt }));
            return;
          }
        } else {
          const dpi = dpiOf(wpx, hpx);
          if (dpi < 150) {
            this.note('art', 'error', T('studio.err_image_small', 'Image trop petite ({w} × {h} px) : environ {dpi} dpi une fois imprimée en {fmt}. Il faut au moins {need} (300 dpi), ou un PDF.', { w: NUM.format(wpx), h: NUM.format(hpx), dpi, fmt, need }));
            return;
          }
        }
        const dpi = type === 'pdf' ? 0 : dpiOf(wpx, hpx);
        art = { mode: 'visuel', name: file.name, file, type, canvas, wmm, hmm, wpx, hpx, dpi, pages, rotated, thumb: artThumb(canvas, zr) };
        this.st.art = art;
        if (rotated) this.note('art', 'info', T('studio.note_rotated', "Votre fichier est au format {format} : il a été pivoté d'un quart de tour pour l'aperçu sur {surface} ({orient}).", { format: zr > 1 ? T('studio.orient_portrait', 'portrait') : T('studio.orient_landscape', 'paysage'), surface: t.surface, orient: t.orient }));
        if (ratioOff) this.note('art', 'warn', T('studio.warn_ratio', 'Proportions différentes du format {fmt} : le visuel est ajusté sans déformation, des bandes blanches peuvent apparaître.', { fmt }));
        if (dpi && dpi < 300) this.note('art', 'warn', T('studio.warn_dpi_visual', 'Résolution un peu juste (environ {dpi} dpi). Pour une impression nette, visez {need} (300 dpi) ou un PDF.', { dpi, need }));
        if (pages > 1) this.note('art', 'info', T('studio.note_pages', 'Votre PDF contient {pages} pages : seule la page 1 (recto) est utilisée.', { pages }));
        if (!ratioOff && (type === 'pdf' || dpi >= 300)) this.note('art', 'ok', type === 'pdf' ? T('studio.ok_format', 'Format {fmt} conforme.', { fmt }) : T('studio.ok_image_hd', "Image haute définition ({dpi} dpi), prête pour l'impression.", { dpi }));
      }
      this.refreshAll();
      this.refreshFlatInk();
      this.renderFlat();
      this.pulse('.c2v-flat');
    }
    // Logo depose sur la page d'accueil : charge dans le studio s'il n'a pas deja un fichier choisi ici
    async useHomeFile(file) {
      if (!file) return;
      const kind = this.flat ? 'art' : 'logo', cur = this.st[kind], key = this.fileKey(file);
      if (cur && this.fileKey(cur.file) !== this.homeKey) return;
      if (cur && this.homeKey === key) return;
      this.homeKey = key;
      // le rendu doit etre pret (visuels charges) avant d'appliquer le fichier
      await this.preload();
      await this.onFile(kind, file, this.flat && !this.ft.logo ? { asLogo: true } : null);
    }
    removeFile(kind) {
      if (kind === 'art') { this.st.art = null; this.renderFlat(); }
      else if (kind === 'logo') { this.st.logo = null; this.renderViews(false); }
      else { this.st.pack = null; if (this.pk) { this.pk.setVisual(null); this.pk.render(this.cPack); } }
      this.q(`[data-notes="${kind}"]`).innerHTML = '';
      this.refreshAll();
    }
    note(kind, level, text) {
      const icon = level === 'error' || level === 'warn' ? I.alert : level === 'ok' ? I.check : I.info;
      const n = document.createElement('p');
      n.className = 'c2v-note c2v-note--' + level;
      n.innerHTML = icon + '<span></span>';
      n.lastChild.textContent = text;
      this.q(`[data-notes="${kind}"]`).appendChild(n);
    }
    pulse(sel) {
      const e = this.q(sel); if (!e) return;
      e.classList.remove('is-pulse'); void e.offsetWidth; e.classList.add('is-pulse');
    }

    /* ---------- quantite et prix */
    qMin() { return this.steps[0].qty; }
    qMax() { return this.steps[this.steps.length - 1].qty; }
    // echelle : lineaire de part et d'autre de la moitie du maximum (5 000 sur 10 000), placee au milieu de la jauge
    qMid() { const a = this.qMin(), b = this.qMax(), m = b / 2; return m > a && m < b ? m : null; }
    qFrac(q) {
      const a = this.qMin(), b = this.qMax(), m = this.qMid();
      if (!(b > a)) return 0;
      if (!m) return clamp((q - a) / (b - a), 0, 1);
      return clamp(q <= m ? 0.5 * (q - a) / (m - a) : 0.5 + 0.5 * (q - m) / (b - m), 0, 1);
    }
    qFromFrac(f) {
      const a = this.qMin(), b = this.qMax(), m = this.qMid();
      f = clamp(f, 0, 1);
      if (!m) return a + f * (b - a);
      return f <= 0.5 ? a + (f / 0.5) * (m - a) : m + ((f - 0.5) / 0.5) * (b - m);
    }
    // palier le plus proche d'une valeur du curseur ; a egalite, celui dans le sens du deplacement
    nearestQi(v) {
      const cur = this.steps[this.st.qi].qty;
      let best = 0, bd = Infinity;
      this.steps.forEach((s, i) => {
        const d = Math.abs(s.qty - v);
        if (d < bd - 0.001 || (Math.abs(d - bd) < 0.001 && (v > cur ? s.qty > this.steps[best].qty : s.qty < this.steps[best].qty))) { best = i; bd = d; }
      });
      return best;
    }
    buildTicks() {
      const box = this.q('.c2v-range__ticks');
      const marks = this.steps.filter(s => s.qty % 1000 === 0 || s.qty === this.cfg.freeFrom);
      box.innerHTML = marks.map(s => `<span class="c2v-range__tick${s.qty === this.cfg.freeFrom ? ' is-free' : ''}" style="--p:${this.qFrac(s.qty)}"><i></i>${s.qty >= 1000 ? NUM.format(s.qty / 1000) + 'k' : s.qty}</span>`).join('');
      this.q('.c2v-range').style.setProperty('--free', this.steps.some(s => s.qty >= this.cfg.freeFrom) ? this.qFrac(this.cfg.freeFrom) : 1);
    }
    // Prix : celui de la variante du produit miroir (personnalisation comprise) quand elle existe,
    // sinon prix du palier de la page + frais de personnalisation
    calc(i) {
      const s = this.steps[clamp(i, 0, this.steps.length - 1)], vat = this.cfg.vat;
      const free = s.qty >= this.cfg.freeFrom, fee = free ? 0 : this.cfg.feeHT * s.qty;
      const v = this.variantFor(s.qty);
      const totalTTC = v ? v.price / 100 : (s.ttc / vat + fee) * vat;
      const totalHT = totalTTC / vat, ht = totalHT - fee;
      return { qty: s.qty, ht, fee, free, totalHT, totalTTC, tva: totalTTC - totalHT, unitHT: totalHT / s.qty };
    }
    setQty(q, push) { const i = this.steps.findIndex(s => s.qty === q); if (i >= 0) this.setQi(i, push); }
    setQi(i, push) {
      i = clamp(i, 0, this.steps.length - 1);
      if (i === this.st.qi) { this.range.value = String(Math.round(this.qFrac(this.steps[i].qty) * 1000)); return; }
      this.st.qi = i;
      this.refreshQty();
      this.refreshFoot();
      if (push) this.pushToPage(true); else this.pushToPage(false);
    }
    gaugeParts() {
      const g = (this.cfg.gauge && document.querySelector(this.cfg.gauge)) || document.querySelector('.quantity-gauge');
      if (!g) return null;
      const r = $('.quantity-gauge__input', g), j = $('[data-quantity-gauge-steps]', g);
      if (!r || !j) return null;
      let steps = [];
      try { steps = JSON.parse(j.textContent); } catch (e) { return null; }
      return { r, steps };
    }
    syncFromPage() {
      const g = this.gaugeParts(); if (!g) return;
      const cur = g.steps[+g.r.value];
      let i = cur ? this.steps.findIndex(s => s.qty === +cur.qty) : -1;
      if (i < 0) i = 0;
      this.st.qi = i;
      this.pushToPage(true);
    }
    pushToPage(now) {
      clearTimeout(this.pushT);
      const run = () => {
        const g = this.gaugeParts(); if (!g) return;
        const q = this.steps[this.st.qi].qty;
        let idx = g.steps.findIndex(s => +s.qty === q);
        if (idx < 0 && g.steps.length && q > +g.steps[g.steps.length - 1].qty) idx = g.steps.length - 1;
        if (idx >= 0 && +g.r.value !== idx) { g.r.value = String(idx); g.r.dispatchEvent(new Event('input', { bubbles: true })); }
      };
      if (now) run(); else this.pushT = setTimeout(run, 260);
    }

    /* ---------- navigation */
    // index des sous-etapes dont le fichier manque
    missing() {
      return this.subs.map((k, i) => (k === 'logo' || k === 'pack' || k === 'art') && !this.st[k] ? i : -1).filter(i => i >= 0);
    }
    lastSub() { return this.subs.length - 1; }
    emailOk() { return this.fieldOk('email'); }
    fieldOk(k) { return CONTACT_OK[k](this.st[k] || ''); }
    contactOk() { return CONTACT_KEYS.every(k => this.fieldOk(k)); }
    fieldErr(k, on) {
      const err = this.q(`[data-c2v-ferr="${k}"]`), inp = this.q(`[data-c2v-f="${k}"]`);
      if (err) err.hidden = !on;
      if (inp) { inp.classList.toggle('is-invalid', on); inp.setAttribute('aria-invalid', on ? 'true' : 'false'); }
    }
    // reprend les coordonnees deja saisies dans un autre studio de la page
    fillContact() {
      CONTACT_KEYS.forEach(k => {
        const inp = this.q(`[data-c2v-f="${k}"]`);
        if (!inp || this.st[k] || !SHARED_CONTACT[k]) return;
        inp.value = SHARED_CONTACT[k]; this.st[k] = SHARED_CONTACT[k];
      });
    }
    contactName() { return `${this.st.first} ${this.st.last}`.trim(); }
    async next() {
      const st = this.st;
      if (this.busyOn) return;
      if (st.step === 1) {
        if (st.sub < this.lastSub()) { this.goSub(st.sub + 1); return; }
        const m = this.missing();
        if (m.length) {
          const k = this.subs[m[0]];
          this.goSub(m[0]);
          this.toast(k === 'logo' || (k === 'art' && this.ft.logo) ? T('studio.toast_need_logo', 'Ajoutez votre logo pour continuer.') : k === 'art' ? T('studio.toast_need_visual', 'Ajoutez votre visuel pour continuer.') : T('studio.toast_need_pack', "Ajoutez le visuel de l'emballage pour continuer."));
          this.pulse(`[data-drop="${k}"]`);
          return;
        }
        this.goStep(2); return;
      }
      if (st.step === 2) {
        const bad = CONTACT_KEYS.filter(k => !this.fieldOk(k));
        if (bad.length) {
          bad.forEach(k => this.fieldErr(k, true));
          const k = bad[0], inp = this.q(`[data-c2v-f="${k}"]`);
          this.toast(bad.length > 1 || !st[k] ? T('studio.toast_contact', 'Complétez vos coordonnées pour continuer.') : k === 'email' ? T('studio.toast_email', 'Indiquez une adresse email valide.') : k === 'phone' ? T('studio.toast_phone', 'Indiquez un numéro de téléphone valide.') : T('studio.toast_contact', 'Complétez vos coordonnées pour continuer.'));
          if (inp) inp.focus();
          return;
        }
        if (!st.approve) { this.toast(T('studio.toast_approve', 'Cochez la case pour continuer.')); this.pulse('.c2v-check--approve'); return; }
        this.busy(true, T('studio.busy_save', 'Enregistrement de votre projet'));
        try { await this.syncCart(); }
        catch (err) { console.warn('[C2V Studio]', err); this.busy(false); this.toast(T('studio.toast_save_failed', "Votre projet n'a pas pu être enregistré. Réessayez.")); return; }
        await this.saveProject('formulaire');
        this.busy(false);
        this.goStep(3); return;
      }
      if (st.step === 3) {
        this.busy(true, T('studio.busy_payment', 'Ouverture du paiement'));
        try { await this.syncCart(); }
        catch (err) { console.warn('[C2V Studio]', err); this.busy(false); this.toast(T('studio.toast_payment_failed', "Le paiement n'a pas pu s'ouvrir. Réessayez.")); return; }
        await this.saveProject('paiement');
        window.location.href = this.checkoutUrl();
      }
    }

    /* ---------- panier, sauvegarde et paiement */
    busy(on, label) {
      this.busyOn = on;
      const next = this.q('[data-c2v-next]');
      next.disabled = on;
      next.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) { next.classList.add('is-soft'); next.innerHTML = `<span class="c2v-btn__l">${esc(label)}…</span><span class="c2v-btn__s">${T('studio.busy_wait', 'Patientez…')}</span>`; }
      else this.refreshFoot();
    }
    variantFor(qty) {
      const p = this.cfg.perso;
      return p && p.variants ? p.variants.find(v => +v.qty === qty && v.available !== false) || null : null;
    }
    persoVariant() { return this.variantFor(this.steps[this.st.qi].qty); }
    // fr : nom francais (proprietes cachees, apercu joint, fiche client), sinon nom traduit
    colorLabel(c, fr) { const n = fr ? c.name : cname(c); return c.hex ? `${n} (${c.hex})` : n; }
    fileKey(f) { return f ? `${f.name}|${f.size}|${f.lastModified}` : ''; }
    // Image de synthese (3D + dessus + emballage + choix) jointe a la commande et a la fiche client
    // Description de l'impression : propriete "Impression" (langue du client) ; fr = francais (fiche client, apercu joint)
    printLabel(fr) {
      const m = this.model, ink = this.st.ink, tr = fr ? TFr : T;
      const color = this.mono() || (this.ft && this.ft.logo && ink.hex) ? tr('cart.print_mono', '1 couleur, {color}', { color: this.colorLabel(ink, fr) }) : tr('cart.print_colors', 'En couleurs');
      const layout = this.st.art && this.st.art.fromLogo ? tr('cart.print_centered', 'logo centré sur fond blanc') : '';
      const orient = m.orient ? (this.horiz() ? tr('cart.print_horizontal', 'impression horizontale') : tr('cart.print_vertical', 'impression verticale')) : '';
      const [pw, ph] = this.printMm(), mm = fr ? fmtMmFr : fmtMm;
      return `${[color, m.relief ? tr('cart.print_relief', 'en relief') : '', orient, layout].filter(Boolean).join(', ')} · ${mm(pw)} × ${mm(ph)} mm`;
    }
    // apercu joint a la commande : piece de production pour l'equipe, textes en francais
    async makePreviewFlat() {
      await this.preload();
      const st = this.st, m = this.mfr, t = this.ft;
      this.renderFlat(true);
      const W = 1600, H = 1000, c = makeCanvas(W, H), x = ctx2d(c);
      x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, W, H);
      const fit = (src, bx, by, bw, bh) => { const k = Math.min(bw / src.width, bh / src.height), w = src.width * k, h = src.height * k; x.drawImage(src, bx + (bw - w) / 2, by + (bh - h) / 2, w, h); };
      fit(this.cvFlat, 40, 40, 860, 880);
      const font = getComputedStyle(this.el).getPropertyValue('--c2v-body').trim() || 'sans-serif';
      if (st.art) {
        x.fillStyle = '#F5F5F5'; x.fillRect(960, 120, 560, 330);
        fit(this.printCanvas(), 990, 145, 500, 280);
      }
      x.fillStyle = '#111111'; x.textBaseline = 'alphabetic';
      x.font = `600 34px ${font}`;
      x.fillText(`${m.name} personnalisé`, 960, 530);
      x.font = `400 26px ${font}`; x.fillStyle = '#374151';
      [`${NUM_FR.format(this.steps[st.qi].qty)} ${this.unitFr}`, this.cs && st.plug ? `${this.csFr.prop || 'Couleur'} : ${st.plug.name.toLowerCase()}` : '', `Impression : ${this.printLabel(true).toLowerCase()}`, st.art ? `${m.artLabel || (t.logo ? 'Logo' : 'Visuel')} : ${st.art.name}` : '']
        .filter(Boolean).forEach((s, i) => x.fillText(s.length > 52 ? s.slice(0, 51) + '…' : s, 960, 585 + i * 40));
      x.fillStyle = '#AD5067'; x.font = `700 20px ${font}`;
      x.fillText('CAPOTE2VERRE · STUDIO DE PERSONNALISATION', 40, 950);
      this.renderFlat();
      const blob = await new Promise(res => c.toBlob(res, 'image/jpeg', 0.88));
      if (!blob) throw new Error('apercu');
      return new File([blob], `apercu-${Date.now()}.jpg`, { type: 'image/jpeg' });
    }
    async makePreview() {
      if (this.flat) return this.makePreviewFlat();
      await this.preload();
      const st = this.st, rgb = st.sil.hex ? hexToRgb(st.sil.hex) : [255, 255, 255], s = st.sil.hex ? 0.92 : 0;
      const zone = st.logo ? st.logo.zone : null, ink = hexToRgb(st.ink.hex);
      cancelAnimationFrame(this.anim.raf);
      this.anim.rgb = rgb; this.anim.strength = st.sil.hex ? 1 : 0;
      this.lid.render(this.c3d, rgb, s, zone, ink);
      this.topv.render(this.cTop, rgb, s, zone, ink);
      this.pk.setVisual(st.pack ? st.pack.canvas : null); this.pk.render(this.cPack);
      const W = 1600, H = 1000, c = makeCanvas(W, H), x = ctx2d(c);
      x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, W, H);
      const fit = (src, bx, by, bw, bh) => { const k = Math.min(bw / src.width, bh / src.height), w = src.width * k, h = src.height * k; x.drawImage(src, bx + (bw - w) / 2, by + (bh - h) / 2, w, h); };
      fit(this.cv3d, 40, 40, 620, 800);
      fit(this.cvTop, 700, 90, 400, 400);
      fit(this.cvPack, 1160, 70, 380, 460);
      const font = getComputedStyle(this.el).getPropertyValue('--c2v-body').trim() || 'sans-serif';
      x.fillStyle = '#111111'; x.textBaseline = 'alphabetic';
      x.font = `600 34px ${font}`;
      x.fillText(`${NUM_FR.format(this.steps[st.qi].qty)} capotes de verre personnalisées`, 700, 630);
      x.font = `400 26px ${font}`; x.fillStyle = '#374151';
      [`Silicone : ${this.colorLabel(st.sil, true)}`, `Couleur du logo : ${this.colorLabel(st.ink, true)}`, st.logo ? `Logo : ${st.logo.name}` : '', st.pack ? `Emballage : ${st.pack.name}` : '']
        .filter(Boolean).forEach((t, i) => x.fillText(t.length > 60 ? t.slice(0, 59) + '…' : t, 700, 685 + i * 40));
      x.fillStyle = '#AD5067'; x.font = `700 20px ${font}`;
      x.fillText('CAPOTE2VERRE · STUDIO DE PERSONNALISATION', 40, 950);
      const blob = await new Promise(res => c.toBlob(res, 'image/jpeg', 0.88));
      if (!blob) throw new Error('apercu');
      return new File([blob], `apercu-${Date.now()}.jpg`, { type: 'image/jpeg' });
    }
    // Ajoute (ou remplace) la ligne de CE projet dans le panier, fichiers compris.
    // Les autres personnalisations deja dans le panier (projets precedents) sont gardees.
    async syncCart() {
      const st = this.st, v = this.persoVariant();
      if (!v) throw new Error('variante personnalisee introuvable');
      const c = this.calc(st.qi);
      const artKey = this.flat ? (this.ft.logo ? '_Logo' : '_Visuel') : '';
      const sig = this.flat
        ? JSON.stringify([v.id, this.fileKey(st.art && st.art.file), st.ink.hex || 'orig', this.horiz() ? 'h' : 'v', st.plug ? st.plug.hex : ''])
        : JSON.stringify([v.id, st.sil, st.ink, this.fileKey(st.logo && st.logo.file), this.fileKey(st.pack && st.pack.file)]);
      const cart = await this.fetchCart();
      const mine = this.cartKey ? cart.items.filter(it => it.key === this.cartKey) : [];
      if (sig === this.cartSig && mine.length) { await this.syncAttrs(); return; }
      if (mine.length) await this.cartPost('/cart/change.js', JSON.stringify({ id: this.cartKey, quantity: 0 }), 'application/json');
      if (sig !== this.cartSig || !this.files) this.files = { preview: await this.makePreview() };
      const fd = new FormData();
      fd.append('id', String(v.id));
      fd.append('quantity', '1');
      const prop = (k, val) => fd.append(`properties[${k}]`, val);
      const upload = (k, f) => { const u = f && this.uploads.get(this.fileKey(f)); if (f) prop(k, u || f); };
      // proprietes visibles (panier, paiement, emails du client) : dans la langue du client
      const perso = c.free ? T('cart.perso_free', 'Offerte') : T('cart.perso_included', 'Incluse ({price} HT / unité)', { price: money(this.cfg.feeHT) });
      if (this.flat) {
        if (this.cs) prop(this.cs.prop || T('cart.prop_color', 'Couleur'), this.plugLabel());
        prop(T('cart.prop_print', 'Impression'), this.printLabel());
        if (this.ft.logo) prop(T('cart.prop_ink', 'Couleur du logo'), st.ink.hex ? this.colorLabel(st.ink) : T('cart.ink_orig', "Couleurs d'origine (fichier tel quel)"));
        prop(T('cart.prop_perso', 'Personnalisation'), perso);
        if (st.art) { prop(this.ft.logo ? T('cart.prop_logo', 'Logo') : T('cart.prop_visual', 'Visuel'), st.art.name); upload(artKey, st.art.file); }
      } else {
        prop(T('cart.prop_silicone', 'Silicone'), this.colorLabel(st.sil));
        prop(T('cart.prop_ink', 'Couleur du logo'), this.colorLabel(st.ink));
        prop(T('cart.prop_perso', 'Personnalisation'), perso);
        if (st.logo) { prop(T('cart.prop_logo', 'Logo'), st.logo.name); upload('_Logo', st.logo.file); }
        if (st.pack) { prop(T('cart.prop_pack', 'Emballage'), st.pack.name); upload('_Emballage', st.pack.file); }
      }
      // proprietes cachees (techniques, equipe) : cles stables, en francais
      prop('_Apercu', this.uploads.get(this.fileKey(this.files.preview)) || this.files.preview);
      prop('_Studio', `${NUM_FR.format(c.qty)} u · ${moneyFr(c.totalHT)} HT · ${new Date().toISOString()}`);
      prop('_Projet_FR', this.summaryFr(c));
      prop('_Langue', LOCALE);
      const fname = this.flat ? st.art && st.art.name : st.logo && st.logo.name;
      if (fname) prop('_Fichier', fname);
      const line = await this.cartPost('/cart/add.js', fd);
      const props = line.properties || {};
      const keep = (f, k) => { if (f && /^https:\/\//.test(props[k] || '')) this.uploads.set(this.fileKey(f), props[k]); };
      if (this.flat) keep(st.art && st.art.file, artKey);
      keep(st.logo && st.logo.file, '_Logo');
      keep(st.pack && st.pack.file, '_Emballage');
      keep(this.files.preview, '_Apercu');
      this.attrSig = '';
      await this.syncAttrs();
      this.cartSig = sig; this.cartKey = line.key; this.cartLine = line;
      document.dispatchEvent(new CustomEvent('c2v:cart', { detail: line }));
      await this.refreshThemeCart();
    }
    // Resume du projet en francais pour l'equipe (propriete cachee _Projet_FR), quelle que soit la langue du client
    summaryFr(c) {
      const st = this.st, m = this.mfr, rows = [['Produit', m.name || (this.cfg.perso && this.cfg.perso.title) || ''], ['Quantité', `${NUM_FR.format(c.qty)} ${this.unitFr}`]];
      if (this.flat) {
        if (this.cs && st.plug) rows.push([this.csFr.prop || 'Couleur', this.plugLabel(true)]);
        rows.push(['Impression', this.printLabel(true)]);
        if (this.ft.logo) rows.push(['Couleur du logo', st.ink.hex ? this.colorLabel(st.ink, true) : "Couleurs d'origine (fichier tel quel)"]);
        if (st.art) rows.push([this.ft.logo ? 'Logo' : 'Visuel', st.art.name]);
      } else {
        rows.push(['Silicone', this.colorLabel(st.sil, true)], ['Couleur du logo', this.colorLabel(st.ink, true)]);
        if (st.logo) rows.push(['Logo', st.logo.name]);
        if (st.pack) rows.push(['Emballage', st.pack.name]);
      }
      rows.push(['Personnalisation', c.free ? 'Offerte' : `Incluse (${moneyFr(this.cfg.feeHT)} HT / unité)`], ['Total', `${moneyFr(c.totalHT)} HT`], ['Langue du client', LOCALE], ['Date', new Date().toLocaleString('fr-FR')]);
      return rows.map(([k, v]) => `${k} : ${v}`).join(' | ');
    }
    fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(r => r.json());
    }
    // compteur et tiroir du panier du theme a jour apres un changement fait par le studio
    async refreshThemeCart(cart) {
      try {
        cart = cart && cart.items ? cart : await this.fetchCart();
        document.querySelectorAll('cart-count').forEach(el => { if (typeof el.onCartUpdate === 'function') el.onCartUpdate({ cart }); });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        await this.cleanAttrs(cart);
      } catch (err) { console.warn('[C2V Studio] panier du theme', err); }
    }
    // plus aucune personnalisation dans le panier : les coordonnees du studio n'ont plus a suivre la commande
    async cleanAttrs(cart) {
      const keys = Object.keys(cart.attributes || {}).filter(k => k.indexOf('Studio : ') === 0 && cart.attributes[k]);
      if (!keys.length || cart.items.some(isStudioLine)) return;
      const attributes = {};
      keys.forEach(k => { attributes[k] = ''; });
      await this.cartPost('/cart/update.js', JSON.stringify({ attributes }), 'application/json');
      this.attrSig = '';
    }

    /* ---------- panier : personnalisations deja ajoutees, retrait, projet suivant */
    async refreshCartList() {
      const box = this.q('[data-c2v-cart]');
      if (!box) return;
      let cart;
      try { cart = await this.fetchCart(); } catch (err) { box.hidden = true; return; }
      this.cartState = cart;
      const lines = cart.items.filter(isStudioLine);
      const others = cart.items.filter(it => !isStudioLine(it)).reduce((n, it) => n + it.quantity, 0);
      if (!lines.length) { box.hidden = true; box.innerHTML = ''; this.refreshFoot(); return; }
      const n = lines.length;
      box.innerHTML = `<p class="c2v-cart__h"><span>${T('studio.cart_title', 'Votre panier')}</span><small>${TP('studio.cart_count', n, '{n} personnalisation', '{n} personnalisations', { n })}</small></p>`
        + `<ul class="c2v-cart__list">${lines.map(it => this.cartLineHtml(it)).join('')}</ul>`
        + (others ? `<p class="c2v-cart__more">${TP('studio.cart_others', others, 'Votre panier contient aussi {n} autre article.', 'Votre panier contient aussi {n} autres articles.', { n: others })}</p>` : '');
      box.hidden = false;
      this.refreshFoot();
    }
    cartLineHtml(it) {
      const p = it.properties || {}, cur = it.key === this.cartKey;
      const img = /^https:\/\//.test(p._Apercu || '') ? p._Apercu : (it.image || '');
      // nom du fichier : propriete cachee _Fichier ; lignes ajoutees avant la traduction : Logo / Visuel (francais)
      const file = p._Fichier || p.Logo || p.Visuel || '';
      const sub = [it.variant_title || '', file].filter(Boolean).join(' · ');
      return `<li class="c2v-cart__i${cur ? ' is-current' : ''}">`
        + (img ? `<img class="c2v-cart__img" alt="" loading="lazy" src="${esc(img)}">` : '<span class="c2v-cart__img"></span>')
        + `<span class="c2v-cart__txt"><b>${esc(it.product_title || '')}</b><small>${cur ? `<em>${T('studio.cart_current', 'Ce projet')}</em>` : ''}${esc(sub)}</small><small class="c2v-cart__price">${T('common.price_ttc', '{price} TTC', { price: money(it.final_line_price / 100) })}</small></span>`
        + `<button type="button" class="c2v-cart__rm" data-c2v-rmline="${esc(it.key)}" aria-label="${esc(T('studio.cart_remove_aria', 'Retirer {name} du panier', { name: it.product_title || T('studio.cart_remove_this', 'cette personnalisation') }))}">${I.trash}<span>${T('studio.cart_remove', 'Retirer')}</span></button></li>`;
    }
    async removeLine(key, btn) {
      if (!key || this.busyOn || (btn && btn.disabled)) return;
      if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
      try {
        const cart = await this.cartPost('/cart/change.js', JSON.stringify({ id: key, quantity: 0 }), 'application/json');
        await this.refreshThemeCart(cart);
        if (key === this.cartKey) {
          // le projet en cours a ete retire : on repart d'un projet vierge
          this.newProject();
          this.toast(T('studio.toast_removed', 'Personnalisation retirée de votre panier.'));
          return;
        }
        this.toast(T('studio.toast_removed', 'Personnalisation retirée de votre panier.'));
        await this.refreshCartList();
      } catch (err) {
        console.warn('[C2V Studio]', err);
        this.toast(T('studio.toast_remove_failed', "La personnalisation n'a pas pu être retirée. Réessayez."));
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
      }
    }
    // le projet en cours doit etre dans le panier avant d'en commencer un autre
    async keepInCart() {
      if (this.busyOn) return false;
      this.busy(true, T('studio.busy_save', 'Enregistrement de votre projet'));
      try { await this.syncCart(); }
      catch (err) { console.warn('[C2V Studio]', err); this.busy(false); this.toast(T('studio.toast_save_failed', "Votre projet n'a pas pu être enregistré. Réessayez.")); return false; }
      this.busy(false);
      return true;
    }
    // « Ajouter un autre produit personnalisé » : accueil = retour aux produits ; fiche produit = choix
    async another(btn) {
      const choice = this.q('[data-c2v-choice]');
      if (choice) {
        const open = choice.hidden;
        choice.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { const f = $('button, a', choice); if (f) f.focus({ preventScroll: true }); }
        return;
      }
      if (!(await this.keepInCart())) return;
      const key = this.cfg.key;
      this.newProject();
      this.close();
      document.dispatchEvent(new CustomEvent('c2v:switch', { detail: { key } }));
    }
    async anotherSame() {
      if (!(await this.keepInCart())) return;
      this.newProject();
      this.toast(T('studio.toast_next_project', 'Votre personnalisation est dans le panier. Vous pouvez composer la suivante.'));
    }
    async anotherOther(href) {
      if (!(await this.keepInCart())) return;
      window.location.href = href;
    }
    // Nouveau projet : coordonnees gardees (case a recocher pour valider le nouvel apercu),
    // le projet precedent reste dans le panier
    newProject() {
      const st = this.st;
      Object.values(this.pickers).forEach(pk => pk.close());
      this.qa('[data-grp][data-i="custom"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      Object.assign(st, {
        sub: 0, seen: new Set([0]), maxStep: 1,
        sil: SILICONES[0], ink: this.flat ? ORIG_INK : INKS[1], inkAuto: !this.flat,
        logo: null, pack: null, art: null, qi: 0,
        plug: this.cs ? (this.cs.colors.find(c => c.base) || this.cs.colors[0]) : null,
        approve: false
      });
      this.cartSig = ''; this.cartKey = ''; this.cartLine = null; this.files = null; this.homeKey = null; this.cartState = null;
      const ap = this.q('[data-c2v-approve]'); if (ap) ap.checked = false;
      ['logo', 'pack', 'art'].forEach(k => { const nb = this.q(`[data-notes="${k}"]`); if (nb) nb.innerHTML = ''; });
      const choice = this.q('[data-c2v-choice]'); if (choice) choice.hidden = true;
      const more = this.q('[data-c2v-another]'); if (more) more.setAttribute('aria-expanded', 'false');
      const box = this.q('[data-c2v-cart]'); if (box) { box.hidden = true; box.innerHTML = ''; }
      if (this.flat) {
        if (this.fv && this.cs) this.fv.setTint(this.plugTint());
        if (this.cs) this.refreshPlug();
        this.refreshFlatInk();
        if (this.model.orient && st.orient !== 'v') this.setOrient('v');
        this.renderFlat();
      } else {
        this.setView('3d');
        if (this.pk) { this.pk.setVisual(null); this.pk.render(this.cPack); }
        this.renderViews(false);
      }
      // quantite : celle de la jauge de la page (fiche produit), sinon le premier palier
      this.syncFromPage();
      this.refreshQty();
      this.refreshAll();
      this.goStep(1);
      this.goSub(0);
    }
    // coordonnees en attributs du panier (visibles dans la commande)
    async syncAttrs() {
      const st = this.st, consent = this.q('.c2v-check--approve span');
      const asig = JSON.stringify([st.company, st.first, st.last, st.phone, st.email, st.approve]);
      if (asig === this.attrSig) return;
      await this.cartPost('/cart/update.js', JSON.stringify({ attributes: {
        'Studio : entreprise': st.company,
        'Studio : contact': this.contactName(),
        'Studio : téléphone': st.phone,
        'Studio : email': st.email,
        'Studio : consentement': `${consent ? consent.textContent.trim() : ''} (case cochée le ${new Date().toLocaleString('fr-FR')})`
      } }), 'application/json');
      this.attrSig = asig;
    }
    async cartPost(url, body, type) {
      const headers = { Accept: 'application/json' };
      if (type) headers['Content-Type'] = type;
      const r = await fetch(url, { method: 'POST', headers, body });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(`${url} ${r.status} ${data.description || data.message || ''}`);
      return data;
    }
    // titleFr : titre francais du produit miroir (productTitleFr), sinon titre de la page
    projectPayload(stage, titleFr) {
      const st = this.st, c = this.calc(st.qi), line = this.cartLine || {}, p = line.properties || {}, v = this.persoVariant();
      const file = (f, k, meta) => f ? { name: f.name, url: p[k] || '', meta } : null;
      const consent = this.q('.c2v-check--approve span');
      const fl = this.flat, a = st.art, logoMode = fl && this.ft.logo;
      const artMeta = a ? (a.mode === 'logo' ? (a.vector ? 'Vectoriel' : `${a.w} × ${a.h} px`) : a.fromLogo ? (a.vector ? 'Logo vectoriel, centré' : `Logo ${a.wpx} × ${a.hpx} px, centré`) : (a.type === 'pdf' ? `PDF ${Math.round(a.wmm)} × ${Math.round(a.hmm)} mm` : `${a.wpx} × ${a.hpx} px`)) : '';
      return {
        email: st.email, consent: st.approve, stage, website: '',
        company: st.company, firstName: st.first, lastName: st.last, phone: st.phone,
        consentText: consent ? consent.textContent.trim() : '',
        project: {
          product: titleFr || (this.cfg.perso ? this.cfg.perso.title : ''),
          kind: this.model.kind, name: this.mfr.name || '', print: fl ? this.printLabel(true) : '',
          options: this.cs && st.plug ? [{ label: this.csFr.prop || 'Couleur', value: this.plugLabel(true) }] : [],
          silicone: fl ? null : { name: st.sil.name, hex: st.sil.hex || '' },
          ink: fl ? null : { name: st.ink.name, hex: st.ink.hex },
          qty: c.qty, totalHT: Math.round(c.totalHT * 100) / 100, totalTTC: v ? v.price / 100 : Math.round(c.totalTTC * 100) / 100,
          unitHT: Math.round(c.unitHT * 1000) / 1000, freePerso: c.free,
          logo: fl ? (logoMode && a ? file(a.file, '_Logo', artMeta) : null) : (st.logo ? file(st.logo, '_Logo', st.logo.vector ? 'Vectoriel' : `${st.logo.w} × ${st.logo.h} px`) : null),
          pack: fl ? (!logoMode && a ? file(a.file, '_Visuel', artMeta) : null) : (st.pack ? file(st.pack, '_Emballage', st.pack.type === 'pdf' ? `${Math.round(st.pack.wmm)} × ${Math.round(st.pack.hmm)} mm` : st.pack.type === 'svg' ? 'Vectoriel' : `${st.pack.wpx} × ${st.pack.hpx} px`) : null),
          preview: p._Apercu ? { name: 'apercu.jpg', url: p._Apercu } : null,
          variantId: v ? String(v.id) : '', page: window.location.href.split('?')[0], lang: LOCALE
        }
      };
    }
    // Titre francais du produit miroir (fiche client) : en francais, celui de la page ; sinon lu sans prefixe
    // de langue (/products/<handle>.js renvoie la langue principale de la boutique), repli sur le titre affiche
    productTitleFr() {
      const p = this.cfg.perso;
      if (!p) return Promise.resolve('');
      if (FR || !p.handle) return Promise.resolve(p.title || '');
      if (!this.titleFrP) {
        this.titleFrP = fetch(`/products/${encodeURIComponent(p.handle)}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(r => (r.ok ? r.json() : null))
          .then(d => (d && d.title) || p.title || '', () => p.title || '');
      }
      return this.titleFrP;
    }
    // Fiche client via le proxy d'app ; un echec ne bloque jamais le parcours
    async saveProject(stage) {
      if (!this.cfg.proxy) return false;
      try {
        const titleFr = await Promise.race([this.productTitleFr(), new Promise(res => setTimeout(() => res(''), 1500))]);
        const req = fetch(this.cfg.proxy.replace(/\/$/, '') + '/save', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(this.projectPayload(stage, titleFr)), keepalive: true, credentials: 'same-origin'
        }).then(r => r.ok, () => false);
        return await Promise.race([req, new Promise(res => setTimeout(() => res(false), 4000))]);
      } catch (err) { console.warn('[C2V Studio] sauvegarde', err); return false; }
    }
    checkoutUrl() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const st = this.st, q = [['email', st.email], ['shipping_address][first_name', st.first], ['shipping_address][last_name', st.last], ['shipping_address][company', st.company], ['shipping_address][phone', phoneE164(st.phone)]];
      return `${root}checkout?` + q.filter(([, v]) => v).map(([k, v]) => `checkout[${k}]=${encodeURIComponent(v)}`).join('&');
    }
    prev() {
      const st = this.st;
      if (st.step === 1 && st.sub > 0) this.goSub(st.sub - 1);
      else if (st.step > 1) { this.goStep(st.step - 1); if (st.step === 1) this.goSub(this.lastSub()); }
    }
    goSub(i) {
      const st = this.st, dir = i >= st.sub ? 1 : -1;
      if (st.step !== 1) this.goStep(1);
      st.sub = i; st.seen.add(i);
      this.qa('.c2v-sub').forEach(s => {
        const on = +s.dataset.sub === i;
        s.classList.toggle('is-active', on);
        s.classList.toggle('from-left', on && dir < 0);
      });
      this.stage.dataset.focus = this.subs[i] === 'pack' ? 'pack' : 'product';
      if (i !== 0 && this.pickers.sil) this.pickers.sil.close();
      this.refreshRail(); this.refreshFoot();
      const sc = this.q('.c2v-scroll'); if (sc) sc.scrollTop = 0;
    }
    goStep(s) {
      const st = this.st, dir = s >= st.step ? 1 : -1;
      if (s === 2) { this.fillContact(); this.productTitleFr(); }
      st.step = s; st.maxStep = Math.max(st.maxStep, s);
      this.qa('.c2v-pane').forEach(p => {
        const on = +p.dataset.pane === s;
        p.classList.toggle('is-active', on);
        p.classList.toggle('from-left', on && dir < 0);
      });
      this.qa('.c2v-steps__i').forEach(b => {
        const n = +b.dataset.step;
        b.classList.toggle('is-active', n === s);
        b.classList.toggle('is-done', n < s || (n <= st.maxStep && n !== s));
      });
      this.stage.dataset.focus = s === 1 && this.subs[st.sub] === 'pack' ? 'pack' : 'product';
      if (s === 3) { this.refreshRecap(); this.refreshCartList(); }
      this.refreshFoot();
      const sc = this.q('.c2v-scroll'); if (sc) sc.scrollTop = 0;
    }

    /* ---------- affichage */
    refreshAll() { if (!this.flat) this.refreshColors(); this.refreshFiles(); this.refreshQty(); this.refreshRail(); this.refreshFoot(); }
    refreshColors() {
      const st = this.st;
      const mark = (grp, cur, list) => {
        this.qa(`[data-grp="${grp}"]`).forEach(b => {
          const i = b.dataset.i;
          const on = i === 'custom' ? cur.id === 'custom' : list[+i] && list[+i].id === cur.id;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (i === 'custom') b.style.setProperty('--sw', cur.id === 'custom' ? cur.hex : 'transparent');
          b.classList.toggle('is-set', i === 'custom' && cur.id === 'custom');
          const ch = i === 'custom' && $('[data-custom-hex]', b);
          if (ch) ch.textContent = cur.id === 'custom' ? cur.hex : T('studio.all_tints', 'Toutes les teintes');
        });
        const p = this.q(`[data-picked="${grp}"]`);
        const hex = cur.hex || '';
        p.innerHTML = `<span>${esc(cname(cur))}</span>${hex ? `<code>${hex}</code>` : `<code>${T('studio.base_tint_lc', 'teinte de base')}</code>`}${grp === 'ink' && st.inkAuto ? `<em>${T('studio.ink_auto', 'choisie automatiquement')}</em>` : ''}`;
      };
      mark('sil', st.sil, SILICONES);
      mark('ink', st.ink, INKS);
      const chipS = this.q('[data-chip="sil"]');
      chipS.style.setProperty('--c', st.sil.hex || NATUREL_REF);
      chipS.lastChild.textContent = cname(st.sil);
      const chipI = this.q('[data-chip="ink"]');
      chipI.hidden = !st.logo;
      chipI.style.setProperty('--c', st.ink.hex);
      chipI.lastChild.textContent = T('studio.chip_ink', 'Logo {color}', { color: cname(st.ink).toLowerCase() });
      // contraste logo / silicone
      const box = this.q('[data-notes="ink"]');
      box.innerHTML = '';
      if (contrast(hexToRgb(st.ink.hex), this.silRgbRef()) < 1.6) {
        const n = document.createElement('p');
        n.className = 'c2v-note c2v-note--warn';
        n.innerHTML = I.alert + `<span>${T('studio.warn_contrast_sil', "Contraste faible entre le logo et le silicone : le logo risque d'être peu visible.")}</span>`;
        box.appendChild(n);
      }
      this.refreshFileCard('logo');
    }
    refreshFiles() { if (this.flat) this.refreshFileCard('art'); else { this.refreshFileCard('logo'); this.refreshFileCard('pack'); } }
    artMeta(f) {
      const ext = (f.name.split('.').pop() || '').toUpperCase();
      if (f.mode === 'logo') return `${f.vector ? T('studio.meta_vector', 'Vectoriel') : `${NUM.format(f.w)} × ${NUM.format(f.h)} px · ${f.dpi} dpi`} · ${f.type === 'raster' ? ext : f.type.toUpperCase()}`;
      if (f.fromLogo) return `${T('studio.meta_centered', 'Logo centré')} · ${f.vector ? T('studio.meta_vector_lc', 'vectoriel') : `${NUM.format(f.wpx)} × ${NUM.format(f.hpx)} px · ${f.dpi} dpi`} · ${f.type === 'raster' ? ext : f.type.toUpperCase()}`;
      return f.type === 'pdf' ? `PDF · ${Math.round(f.wmm)} × ${Math.round(f.hmm)} mm` : `${ext} · ${NUM.format(f.wpx)} × ${NUM.format(f.hpx)} px · ${f.dpi} dpi`;
    }
    refreshFileCard(kind) {
      const card = this.q(`[data-filecard="${kind}"]`), drop = this.q(`[data-drop="${kind}"]`), f = this.st[kind];
      card.hidden = !f; drop.classList.toggle('is-compact', !!f);
      $('.c2v-drop__t', drop).innerHTML = f ? T('studio.drop_replace', 'Remplacer le fichier : <u>parcourir</u> ou glisser ici') : (kind === 'logo' || (kind === 'art' && this.ft.logo) ? T('studio.drop_logo', 'Glissez votre logo ici ou <u>parcourez vos fichiers</u>') : T('studio.drop_file', 'Glissez votre fichier ici ou <u>parcourez vos fichiers</u>'));
      if (!f) { card.innerHTML = ''; return; }
      let meta, thumb;
      if (kind === 'art') {
        meta = this.artMeta(f);
        thumb = this.printThumb();
      } else if (kind === 'logo') {
        meta = `${f.vector ? T('studio.meta_vector', 'Vectoriel') : `${NUM.format(f.w)} × ${NUM.format(f.h)} px`} · ${f.type === 'raster' ? (f.name.split('.').pop() || '').toUpperCase() : f.type.toUpperCase()}`;
        thumb = this.logoThumb();
      } else {
        meta = this.packMeta(f);
        thumb = f.thumb.toDataURL('image/png');
      }
      card.innerHTML = `<span class="c2v-file__th c2v-file__th--${kind}"><img alt="" src="${thumb}"></span><span class="c2v-file__txt"><b></b><small>${esc(meta)}</small></span><button type="button" class="c2v-file__rm" data-remove="${kind}" aria-label="${esc(T('studio.remove_file_aria', 'Retirer le fichier'))}">${I.trash}</button>`;
      $('b', card).textContent = f.name;
    }
    logoThumb() {
      const z = this.st.logo.zone, W = 132, H = 88;
      const c = makeCanvas(W, H), cx = ctx2d(c);
      cx.fillStyle = this.st.sil.hex || '#EEEEF0'; cx.fillRect(0, 0, W, H);
      const t = makeCanvas(W, H), tx = ctx2d(t);
      const k = Math.min(W * 0.84 / z.bw, H * 0.84 / z.bh);
      tx.drawImage(z.sil, (W - z.bw * k) / 2, (H - z.bh * k) / 2, z.bw * k, z.bh * k);
      tx.globalCompositeOperation = 'source-in'; tx.fillStyle = this.st.ink.hex; tx.fillRect(0, 0, W, H);
      cx.drawImage(t, 0, 0);
      return c.toDataURL('image/png');
    }
    refreshQty() {
      const c = this.calc(this.st.qi), n = this.steps.length - 1;
      this.range.value = String(Math.round(this.qFrac(c.qty) * 1000));
      this.range.setAttribute('aria-valuetext', T('studio.qty_units', '{qty} unités', { qty: NUM.format(c.qty) }));
      this.q('.c2v-range').style.setProperty('--p', this.qFrac(c.qty));
      this.q('[data-c2v-qtynum]').textContent = NUM.format(c.qty);
      this.q('[data-c2v-bigqty]').textContent = NUM.format(c.qty);
      this.q('[data-bill="qty"]').innerHTML = this.billRows(c, false);
      // incitations : palier "personnalisation offerte", puis palier suivant moins cher au total
      const nudge = this.q('[data-nudge]'), u = esc(this.unit);
      const fi = this.steps.findIndex(s => s.qty >= this.cfg.freeFrom);
      let cj = -1;
      if (c.free) for (let j = this.st.qi + 1; j < this.steps.length; j++) { if (this.calc(j).totalHT <= c.totalHT + 0.005) { cj = j; break; } }
      if (!c.free && fi >= 0) {
        const f = this.calc(fi), diff = f.totalHT - c.totalHT, qf = NUM.format(f.qty);
        let txt;
        if (diff <= 0) txt = T('studio.nudge_free_less', '<b>À {qty} unités, vous payez {amount} HT de moins</b> tout en recevant {more} {unit} de plus : la personnalisation y est offerte.', { qty: qf, amount: money(-diff), more: NUM.format(f.qty - c.qty), unit: u });
        else txt = T('studio.nudge_free_more', "<b>À {qty} unités, la personnalisation est offerte.</b> Seulement {amount} HT de plus pour {more} {unit} supplémentaires, soit {unit_price} HT l'unité.", { qty: qf, amount: money(diff), more: NUM.format(f.qty - c.qty), unit: u, unit_price: money(f.unitHT) });
        nudge.hidden = false;
        nudge.classList.toggle('is-hot', diff <= 0);
        nudge.innerHTML = `<span class="c2v-nudge__ic">${I.spark}</span><p>${txt}</p><button type="button" class="c2v-nudge__b" data-to="${f.qty}">${T('studio.nudge_go', 'Passer à {qty}', { qty: qf })}</button>`;
      } else if (cj >= 0) {
        const f = this.calc(cj), save = c.totalHT - f.totalHT, qf = NUM.format(f.qty), more = NUM.format(f.qty - c.qty);
        const txt = save > 0.005
          ? T('studio.nudge_less', '<b>À {qty} unités, vous payez {amount} HT de moins</b> et recevez {more} {unit} de plus : le prix unitaire passe à {unit_price} HT.', { qty: qf, amount: money(save), more, unit: u, unit_price: money(f.unitHT) })
          : T('studio.nudge_same', '<b>À {qty} unités, même prix total</b> pour {more} {unit} de plus : le prix unitaire passe à {unit_price} HT.', { qty: qf, more, unit: u, unit_price: money(f.unitHT) });
        nudge.hidden = false;
        nudge.classList.add('is-hot');
        nudge.innerHTML = `<span class="c2v-nudge__ic">${I.spark}</span><p>${txt}</p><button type="button" class="c2v-nudge__b" data-to="${f.qty}">${T('studio.nudge_go', 'Passer à {qty}', { qty: qf })}</button>`;
      } else {
        nudge.hidden = !c.free;
        nudge.classList.remove('is-hot');
        if (c.free) nudge.innerHTML = `<span class="c2v-nudge__ic">${I.check}</span><p>${T('studio.nudge_free_now', '<b>Personnalisation offerte</b> à partir de {qty} unités. Vous économisez {amount} HT.', { qty: NUM.format(this.cfg.freeFrom), amount: money(this.cfg.feeHT * c.qty) })}</p>`;
      }
    }
    billRows(c, full) {
      const row = (k, v, cls = '') => `<div class="c2v-bill__r ${cls}"><dt>${k}</dt><dd>${v}</dd></div>`;
      return row(`${NUM.format(c.qty)} ${esc(this.unit)}`, T('common.price_ht', '{price} HT', { price: money(c.ht) }))
        + row(`${T('studio.bill_perso', 'Personnalisation')} <small>${T('common.unit_price_ht', '{price} HT / unité', { price: money(this.cfg.feeHT) })}</small>`, c.free ? `<s>${money(this.cfg.feeHT * c.qty)}</s> <b class="c2v-free">${T('studio.free', 'Offerte')}</b>` : T('common.price_ht', '{price} HT', { price: money(c.fee) }))
        + row(T('studio.total_ht', 'Total HT'), money(c.totalHT), 'is-sub')
        + row(T('studio.vat', 'TVA {rate} %', { rate: Math.round((this.cfg.vat - 1) * 100) }), money(c.tva))
        + row(T('studio.total_ttc', 'Total TTC'), money(c.totalTTC), 'is-total')
        + (full ? '' : row(T('studio.unit_price', 'Prix unitaire'), T('common.price_ht', '{price} HT', { price: money(c.unitHT) }), 'is-unit'));
    }
    refreshRail() {
      const st = this.st, n = this.subs.length;
      const done = this.subs.map((k, i) => (k === 'color' || k === 'qty' || k === 'plug') ? st.seen.has(i) : !!st[k]);
      this.qa('.c2v-rail__i').forEach(b => {
        const i = +b.dataset.sub;
        b.classList.toggle('is-active', i === st.sub);
        b.classList.toggle('is-done', done[i] && i !== st.sub);
      });
      this.q('.c2v-rail__bar i').style.width = ((st.sub + 1) / n * 100) + '%';
      if (this.flat) {
        this.q('[data-chip="art"]').hidden = !st.art;
        this.stage.classList.toggle('has-art', !!st.art);
        return;
      }
      const chipP = this.q('[data-chip="pack"]'); chipP.hidden = !st.pack;
      this.q('.c2v-pack').classList.toggle('has-visual', !!st.pack);
    }
    refreshFoot() {
      const st = this.st, c = this.calc(st.qi);
      this.q('[data-c2v-ht]').textContent = money(c.totalHT);
      this.q('[data-c2v-ttc]').textContent = T('common.price_ttc', '{price} TTC', { price: money(c.totalTTC) });
      this.q('[data-c2v-unit]').textContent = T('common.unit_price_ht', '{price} HT / unité', { price: money(c.unitHT) });
      this.q('[data-c2v-fq]').textContent = NUM.format(c.qty);
      const next = this.q('[data-c2v-next]'), prev = this.q('[data-c2v-prev]');
      prev.hidden = st.step === 1 && st.sub === 0;
      let label = T('studio.btn_continue', 'Continuer'), short = label, ready = true;
      if (st.step === 1) {
        if (st.sub === this.lastSub()) { label = T('studio.btn_validate', 'Valider ma personnalisation'); short = T('studio.btn_validate_short', 'Valider'); ready = !this.missing().length; }
      } else if (st.step === 2) { label = T('studio.btn_to_payment', 'Continuer vers le paiement'); ready = this.contactOk() && st.approve; }
      else {
        // plusieurs articles dans le panier : le paiement porte sur tout le panier
        const v = this.persoVariant(), cs = this.cartState;
        const all = cs && cs.items && cs.items.some(it => it.key !== this.cartKey);
        label = T('studio.btn_pay', 'Payer {price}', { price: money(all ? cs.total_price / 100 : (v ? v.price / 100 : c.totalTTC)) }); short = T('studio.btn_pay_short', 'Payer');
      }
      next.classList.toggle('is-soft', !ready);
      next.classList.toggle('is-pay', st.step === 3);
      next.innerHTML = (st.step === 3 ? I.lock : '') + `<span class="c2v-btn__l">${esc(label)}</span><span class="c2v-btn__s">${esc(short)}</span>` + (st.step === 3 ? '' : I.arrow);
    }
    refreshRecap() {
      const st = this.st, c = this.calc(st.qi);
      if (this.flat) return this.refreshRecapFlat(c);
      const li = (k, v, goto) => `<li><span class="c2v-recap__k">${k}</span><span class="c2v-recap__v">${v}</span>${goto ? `<button type="button" class="c2v-recap__e" data-goto="${goto}">${T('studio.edit', 'Modifier')}</button>` : ''}</li>`;
      const dot = hex => `<i class="c2v-dot" style="--c:${hex}"></i>`;
      const none = `<span>${T('studio.none', 'Aucun')}</span>`;
      const logo = st.logo ? `<img class="c2v-recap__img" alt="" src="${this.logoThumb()}"><span>${esc(st.logo.name)}<small>${T('studio.recap_ink', 'Impression {color} {hex}', { color: esc(cname(st.ink).toLowerCase()), hex: st.ink.hex })}</small></span>` : none;
      const pack = st.pack ? `<img class="c2v-recap__img c2v-recap__img--pack" alt="" src="${st.pack.thumb.toDataURL('image/png')}"><span>${esc(st.pack.name)}<small>${st.pack.type === 'pdf' ? T('studio.recap_pack', 'PDF recto · {w} × {h} mm', { w: Math.round(st.pack.wmm), h: Math.round(st.pack.hmm) }) : esc(this.packMeta(st.pack))}</small></span>` : none;
      this.q('[data-recap]').innerHTML =
        li(T('studio.silicone', 'Silicone'), `${dot(st.sil.hex || NATUREL_REF)}<span>${esc(cname(st.sil))}<small>${st.sil.hex || T('studio.base_tint_lc', 'teinte de base')}</small></span>`, '1:0')
        + li(T('studio.logo', 'Logo'), logo, '1:1')
        + li(T('studio.pack', 'Emballage'), pack, '1:2')
        + li(T('studio.quantity', 'Quantité'), `<span>${T('studio.qty_units', '{qty} unités', { qty: NUM.format(c.qty) })}<small>${T('common.unit_price_ht', '{price} HT / unité', { price: money(c.unitHT) })}</small></span>`, '1:3')
        + li(T('studio.contact', 'Contact'), this.recapContact(), '2:0');
      this.q('[data-bill="final"]').innerHTML = this.billRows(c, true);
    }
    refreshRecapFlat(c) {
      const st = this.st, t = this.ft, m = this.model;
      const li = (k, v, goto) => `<li><span class="c2v-recap__k">${k}</span><span class="c2v-recap__v">${v}</span>${goto ? `<button type="button" class="c2v-recap__e" data-goto="${goto}">${T('studio.edit', 'Modifier')}</button>` : ''}</li>`;
      const art = st.art ? `<img class="c2v-recap__img c2v-recap__img--art" alt="" src="${this.printThumb()}"><span>${esc(st.art.name)}<small>${esc(this.printLabel())}</small></span>` : `<span>${T('studio.none', 'Aucun')}</span>`;
      const ia = this.subs.indexOf('art'), iq = this.subs.indexOf('qty'), ip = this.subs.indexOf('plug');
      const plug = this.cs && st.plug ? li(esc(this.cs.recap || T('studio.color', 'Couleur')), `<i class="c2v-dot" style="--c:${st.plug.hex}"></i><span>${esc(cname(st.plug))}<small>${esc(st.plug.hex)}</small></span>`, `1:${ip}`) : '';
      this.q('[data-recap]').innerHTML =
        li(T('studio.product', 'Produit'), `<span>${esc(m.name || '')}<small>${esc(t.print)}</small></span>`, '')
        + plug
        + li(esc(t.label), art, `1:${ia}`)
        + li(T('studio.quantity', 'Quantité'), `<span>${NUM.format(c.qty)} ${esc(this.unit)}<small>${T('common.unit_price_ht', '{price} HT / unité', { price: money(c.unitHT) })}</small></span>`, `1:${iq}`)
        + li(T('studio.contact', 'Contact'), this.recapContact(), '2:0');
      this.q('[data-bill="final"]').innerHTML = this.billRows(c, true);
    }
    recapContact() {
      const st = this.st;
      return `<span>${esc(this.contactName())}${st.company ? `<small>${esc(st.company)}</small>` : ''}<small>${esc(st.phone)}</small><small class="c2v-recap__mail">${esc(st.email)}</small></span>`;
    }
    toast(msg) {
      const t = this.q('.c2v-toast');
      t.textContent = msg; t.classList.add('is-on');
      clearTimeout(this.toastT); this.toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
    }
  }

  function readCfg(el) {
    const ds = el.dataset;
    let steps = [], images = {}, perso = null, model = null;
    try { steps = JSON.parse($('[data-c2v-steps]', el).textContent); } catch (e) { /* vide */ }
    try { images = JSON.parse($('[data-c2v-images]', el).textContent); } catch (e) { /* vide */ }
    try { perso = JSON.parse($('[data-c2v-perso]', el).textContent); } catch (e) { /* vide */ }
    try { const me = $('[data-c2v-model]', el); if (me) model = JSON.parse(me.textContent); } catch (e) { /* vide */ }
    if (model && model.kind === 'flat' && !(model.mm && model.mm[0] > 0 && model.mm[1] > 0)) model = null;
    // textes du modele traduits (cles c2v.model.<cle>.*) ; le metachamp d'origine (francais) reste dans model.fr
    model = localModel(model);
    return {
      feeHT: parseFloat(ds.feeHt || '0.2'), freeFrom: parseInt(ds.freeFrom || '3000', 10), minQty: parseInt(ds.minQty || '1000', 10),
      vat: parseFloat(ds.vat || '1.2'), gauge: ds.gauge || '', privacy: ds.privacyUrl || '/policies/privacy-policy', terms: ds.termsUrl || '/policies/terms-of-service',
      maxQty: parseInt(ds.maxQty || '0', 10), extStep: parseInt(ds.extStep || '500', 10),
      proxy: ds.proxy || '', perso, model,
      key: ds.c2vKey || '', home: el.hasAttribute('data-c2v-home'), uid: ds.c2vKey ? '-' + ds.c2vKey.replace(/[^a-z0-9_-]/gi, '') : '',
      steps: steps.map(s => ({ id: s.id, qty: +s.qty, ttc: s.price / 100 })).filter(s => s.qty > 0).sort((a, b) => a.qty - b.qty),
      images
    };
  }

  /* ---------------------------------------------------------------- Demarrage */
  function init() {
    const els = $$('[data-c2v-studio]');
    if (!els.length || window.C2VStudios) return;
    const studios = new Map();
    const get = key => {
      key = key || '';
      if (studios.has(key)) return studios.get(key);
      const el = els.find(x => (x.dataset.c2vKey || '') === key) || (key ? null : els[0]);
      if (!el) return null;
      const s = new Studio(el);
      studios.set(key, s);
      return s;
    };
    window.C2VStudios = {
      get,
      async open(key, opts) {
        const s = get(key);
        if (!s) return null;
        const o = opts || {};
        window.C2VStudio = s;
        s.open(o.trigger);
        if (o.file) await s.useHomeFile(o.file);
        return s;
      }
    };
    const home = els.some(x => x.hasAttribute('data-c2v-home'));
    // fiche produit : un seul studio, cree tout de suite (comme avant)
    const first = home ? null : get(els[0].dataset.c2vKey || '');
    if (first) window.C2VStudio = first;
    document.addEventListener('click', e => {
      const t = e.target.closest('[data-c2v-open], .quantity-gauge__cta--personalize');
      if (!t) return;
      const key = t.dataset.c2vOpen || '';
      if (home && !key) return;
      e.preventDefault();
      window.C2VStudios.open(key, { trigger: t });
    });
    if (!first) return;
    // prechargement discret des visuels
    const warm = () => first.preload();
    const btn = document.querySelector('[data-c2v-open], .quantity-gauge__cta--personalize');
    if (btn) ['pointerenter', 'focus', 'touchstart'].forEach(ev => btn.addEventListener(ev, warm, { once: true, passive: true }));
    const idle = window.requestIdleCallback || (cb => setTimeout(cb, 2500));
    window.addEventListener('load', () => idle(warm, { timeout: 4000 }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
